<template>
  <div class="animated fadeIn " >
    <b-card 
      header-bg-variant="dark"
      header-text-variant="white"
      header-tag="header"
      body-class="alert-dark"
    >
      <template #header >
        <div class="d-flex justify-content-between align-items-center p-0" >
          <div>
            <b-avatar icon="handbag-fill"></b-avatar>
            <strong class="ml-2">COMPRA DE GADO</strong> <small>Formulário</small>
          </div>
          <div class="d-flex">
            <b-button  
                  type="button"  
                  class="p-1 px-3 font-weight-bold ml-2" 
                  variant="info" 
                  @click="voltar()">
                <i class="fa fa-arrow-left"></i> Voltar
            </b-button>
            <b-button  
                  v-if="habilitarBotaoGravar"
                  variant="success"
                  class="px-3 font-weight-bold ml-2"
                  :isLoading="isLoading" 
                  :disabled="isLoading"
                  :status="status"
                  
                  @click.stop.prevent="post()">
                <i class="fa fa-save"></i> Gravar
            </b-button>   
            <b-button  v-if="habilitarBotaoReabrir"
                          variant="warning"  
                          ref="btReabrir"
                          class="px-3 font-weight-bold ml-2"
                          @click="abrirModalReabrir()">
                <i class="fa fa-check"></i>  Reabrir
            </b-button>
            <b-button  
                  v-if="habilitarBotaoAlterar"
                  variant="success"
                  class="px-3 font-weight-bold ml-2"
                  :isLoading="isLoading" 
                  :disabled="isLoading"
                  :status="status"
                  
                  @click.stop.prevent="edit()">
                <i class="fa fa-save"></i> Gravar Alterações
            </b-button>   
          </div>
        </div>
      </template>

            
              <b-row class="my-0">
                <!--/.col-->
                <b-col sm="2">
                  <b-form-group>
                    <label >ID Controle</label>
                    <b-form-input  type="text" 
                                  :disabled="true"
                                  id="edID" placeholder="Automatico" 
                                  v-model="registro.dados.ID" 
                                  > </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Situação">
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzirSituacao(registro.dados.OP_STATUS)"></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <!--/.col-->
                <b-col sm="2">
                  <b-form-group>
                    <label >GTA</label>
                    <b-form-input  type="text" 
                                  :state="!!registro.dados.GTA"
                                  :disabled="formHabilitado"
                                  id="edID" placeholder="Informe o GTA" 
                                  v-model="registro.dados.GTA" 
                                  > </b-form-input>
                  </b-form-group>
                </b-col>
                  <!--/.col-->
                  <b-col sm="2">
                        <b-overlay :show="modalAbate.parametros.busy" 
                                      rounded="lg" 
                                      opacity="0.6">
                          <template #overlay>
                            <div class="d-flex align-items-center">
                              <b-spinner small type="grow" variant="secondary"></b-spinner>
                              <b-spinner type="grow" variant="dark"></b-spinner>
                              <b-spinner small type="grow" variant="secondary"></b-spinner>
                              <span class="sr-only">Por favor. Aguarde...</span>
                            </div>
                          </template>
                          <b-form-group
                                id="fieldset-1"
                                description="Use o botão para localizar o Abate."
                                label="Número do Abate"
                                label-for="ob_edDocumento"
                                valid-feedback="Gerado!">
                              <b-input-group  :aria-hidden="modalAbate.parametros.busy ? 'true' : null">
                                  <b-form-input type="text" 
                                    id="ob_edDocumento" 
                                    v-model="registro.dados.ABATE_ID"
                                    :disabled="true"
                                    placeholder="(Opcional) numero do Abate" > 
                                  </b-form-input>
                                  <b-input-group-append v-if="registro.dados.ABATE_ID === null">
                                      <b-button v-if="!desabilitado"
                                                ref="bt_gerarDocumento" 
                                                :disabled="formHabilitado"
                                                variant="primary"  
                                                @click="abrirModalAbate()">
                                        Abate
                                      </b-button>
                                  </b-input-group-append>
                              </b-input-group>
                          </b-form-group>
                        </b-overlay>

                  </b-col>
                  
              </b-row>
              <hr>
              <div>
                  <b-row class="my-0">
                    <!--/.col-->
                    <b-col sm="6">
                      <b-form-group>
                        <cliente-pesquisa 
                                          @retornaId="registro.dados.ID_FORNECEDOR = $event"
                                          :idInicial="registro.dados.ID_FORNECEDOR"
                                          :classe-required="!registro.dados.ID_FORNECEDOR"
                                          ref="edID_FORNECEDOR"
                                          label="Fornecedor"
                                          place="Informe o Fornecedor"
                                          :desabilitarInput="formHabilitado"
                                          labelBotao="">
                        </cliente-pesquisa>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="2">
                      <b-form-group>
                        <label >Documento\Minuta</label>
                        <b-form-input  type="text" 
                                      id="edTX_MINUTA" placeholder="Informe" 
                                      v-model="registro.dados.TX_MINUTA" 
                                      :disabled="formHabilitado"
                                      :state="!!registro.dados.TX_MINUTA"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="2">
                      <b-form-group>
                        <label >Data Vencimento</label>
                        <b-form-input  type="date" 
                                      id="dtVencimento" placeholder="Informe" 
                                      v-model="registro.dados.DT_VENCIMENTO" 
                                      :disabled="formHabilitado"
                                      :state="!!registro.dados.DT_VENCIMENTO"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="2">
                      <b-form-group>
                        <label >Data Abate</label>
                        <b-form-input  type="date" 
                                      id="edDT_ABATE" placeholder="Informe" 
                                      v-model="registro.dados.DT_ABATE" 
                                      :disabled="formHabilitado"
                                      :state="!!registro.dados.DT_ABATE"> </b-form-input>
                      </b-form-group>
                    </b-col>
                    
                  </b-row>
                  <b-row class="my-0">
                    <!--/.col-->
                    <b-col sm="3">
                      <b-form-group>
                        <funcionario-pesquisa 
                                          @retornaId="registro.dados.ID_COMPRADOR = $event"
                                          :idInicial="registro.dados.ID_COMPRADOR"
                                          :desabilitarInput="formHabilitado"
                                          :classe-required="!valID_COMPRADOR"
                                          label="Comprador"
                                          place="Informe o Comprador"
                                          labelBotao="">
                        </funcionario-pesquisa>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="3">
                      <b-form-group>
                        <transportadora-pesquisa 
                                          @retornaId="registro.dados.TRANSPORTADORA_ID = $event"
                                          :idInicial="registro.dados.TRANSPORTADORA_ID"
                                          :desabilitarInput="formHabilitado"
                                          :classe-required="!registro.dados.TRANSPORTADORA_ID"
                                          label="Transportadora"
                                          place="Informe"
                                          labelBotao="">
                        </transportadora-pesquisa>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="2">
                      <b-form-group>
                        <label >Frete R$:</label>
                        <vue-autonumeric  v-model="registro.dados.VL_FRETE" 
                                          :disabled="formHabilitado"
                                            :options="{
                                                  digitGroupSeparator: '.',
                                                  decimalCharacter: ',',
                                                  decimalCharacterAlternative: '.',
                                                  roundingMethod: 'U',
                                                  minimumValue: '0'
                                            }"
                                            class='form-control text-right'>
                          </vue-autonumeric>
                      </b-form-group>
                    </b-col>
                    <!--/.col-->
                    <b-col sm="2">
                      <b-form-group>
                        <label >Placa:</label>
                        <b-form-input  type="text" 
                                      id="edTX_PLACA" placeholder="Informe" 
                                      v-model="registro.dados.TX_PLACA" 
                                      :disabled="formHabilitado"
                                      > </b-form-input>
                      </b-form-group>
                    </b-col>
                    
                    
                  </b-row>
                  <hr>
                  
                  <b-row>
                    <!-- BOI -->
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="BOI"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_PESO" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                    <!-- NOVILHA -->
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="NOVILHA"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_NOVILHA4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_NOVILHA4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_NOVILHA4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_NOVILHA3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_NOVILHA3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_NOVILHA3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_NOVILHA2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_NOVILHA2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_NOVILHA2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_NOVILHA1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_NOVILHA1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_NOVILHA1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_NOVILHA0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_NOVILHA0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_NOVILHA0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_NOVILHA0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_NOVILHA0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                  </b-row>
                  <p></p>
                  <b-row >
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="BOI"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                    <!-- TOURO -->
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="TOURO"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_TOURO4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_TOURO4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_TOURO4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_TOURO3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_TOURO3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_TOURO3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_TOURO2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_TOURO2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_TOURO2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_TOURO1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_TOURO1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_TOURO1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_TOURO0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_TOURO0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_TOURO0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_TOURO0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_TOURO0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                  </b-row>
                  <p></p>
                  <b-row >
                    <!-- BUFALO MACHO -->
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="Bufalo"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_MACHO4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_MACHO4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_MACHO4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_MACHO3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_MACHO3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_MACHO3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_MACHO2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_MACHO2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_MACHO2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_MACHO1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_MACHO1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_MACHO1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_MACHO0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_MACHO0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_MACHO0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_MACHO0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_MACHO0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                    <!-- BUFALO FEMEA -->
                    <b-col sm="6">
                      <b-input-group  >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="Bufala"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_FEMEA4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_FEMEA4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_FEMEA4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_FEMEA3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_FEMEA3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_FEMEA3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_FEMEA2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_FEMEA2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_FEMEA2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_FEMEA1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_FEMEA1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_FEMEA1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BUFALO_FEMEA0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BUFALO_FEMEA0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BUFALO_FEMEA0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BUFALO_FEMEA0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BUFALO_FEMEA0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                    </b-col>
                  </b-row>
                  <p></p>
                  <b-row>
                  <!-- BOI CAPAO -->
                    <b-col sm="6">
                      <b-input-group >
                        <b-form-input class="font-weight-bold" :disabled="true" placeholder="Boi Capão"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Peso KG"> </b-form-input>
                        <b-form-input :disabled="true" placeholder="Cabeças"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Média"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Preço @"></b-form-input>
                        <b-form-input :disabled="true" placeholder="Total"></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 04" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO4_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO4_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO4_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO4_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.faixa4.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI_CAPAO4_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI_CAPAO4_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO4_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI_CAPAO4_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>

                      <b-input-group prepend="FAIXA 03" >
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO3_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO3_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO3_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO3_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.faixa3.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI_CAPAO3_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI_CAPAO3_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO3_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI_CAPAO3_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 02">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO2_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO2_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO2_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO2_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.faixa2.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI_CAPAO2_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI_CAPAO2_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO2_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI_CAPAO2_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 01">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO1_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO1_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO1_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO1_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.faixa1.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI_CAPAO1_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI_CAPAO1_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO1_TOTAL"  class="form-control text-right" disabled
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI_CAPAO1_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                      <b-input-group prepend="FAIXA 00">
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO0_PESO"  :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO0_PESO}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO0_PECAS" v-bind="formatoPecas" :class="['form-control text-right', {'text-red':  registro.dados.NR_BOI_CAPAO0_PECAS}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.faixa0.media"  class="form-control text-right" disabled> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.VL_BOI_CAPAO0_ARROBA"  :class="['form-control text-right', {'text-red':  registro.dados.VL_BOI_CAPAO0_ARROBA}]"> </vue-autonumeric>
                        <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="registro.dados.NR_BOI_CAPAO0_TOTAL"  class="form-control text-right" disabled 
                              :class="['form-control', 'text-right', {'is-invalid': !validouNR_BOI_CAPAO0_TOTAL && submmited} ]"> </vue-autonumeric>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  
                  <p></p>
                  <hr>
                  <b-row >
                    <!-- RESUMO DOS PESOS -->
                    <b-col sm="4">
                      <b-card body-class="bg-gray-100">
                        <div slot="header">
                          <i class='fa fa-align-justify'></i><strong>  RESUMO DOS PESOS </strong>
                        </div>
                          <!--BOI -->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">BOI</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.BOI.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.BOI.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row> 
                          <!--BOI -->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">BOI</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.boi.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boi.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          <!--TOURO -->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">TOURO</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.touro.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.touro.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          <!--NOVILHA -->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">NOVILHA</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.novilha.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.novilha.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          <!--CAPAO -->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">BOI CAPAO</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.boicapao.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.boicapao.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          <!--BUF. MACHO-->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">BUFALO</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.bufalomacho.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalomacho.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          <!--BUFALO FEMEA-->
                          <b-row class="p-1">
                            <b-col sm="4" class="font-weight-bold text-right">
                                <span  class="font-weight-bold text-right">BUFALA</span>
                            </b-col>
                            <b-col sm="4">
                              <b-form-input type="text" class="font-weight-bold text-right" :disabled="true" v-model="animais.bufalofemea.pecasTotal"></b-form-input>
                            </b-col>
                            <b-col sm="4"> 
                              <vue-autonumeric :options="'commaDecimalCharDotSeparator'" v-model="animais.bufalofemea.pesoTotal"  :disabled="true" class="form-control text-right font-weight-bold"> </vue-autonumeric>
                            </b-col>  
                          </b-row>
                          
                      </b-card>
                    </b-col>
                    <!-- OUTRAS INFORMACOES -->
                    <b-col sm="4">
                      <b-row>
                        <!-- INFORMACOES -->
                        <b-col sm="12">
                          <b-card body-class="bg-gray-100">
                            <div slot="header">
                              <i class='fa fa-credit-card'></i> <strong>Outras Informações</strong>
                            </div>
                            <b-row>
                              <!--/.col-->
                              <b-col sm="12" >
                                <!--row-->
                                <b-row class="p-1">
                                  <b-col sm="6"  class="text-right p-1" >
                                    <label >TOTAL LÍQUIDO R$:</label>
                                  </b-col>
                                  <b-col sm="6">
                                    <vue-autonumeric  v-model="registro.dados.VL_TOTAL_BATE" 
                                                      :disabled="true"
                                                        :options="{
                                                              digitGroupSeparator: '.',
                                                              decimalCharacter: ',',
                                                              decimalCharacterAlternative: '.',
                                                              decimalPlaces: '2',
                                                              roundingMethod: 'U',
                                                              minimumValue: '0'
                                                        }"
                                                        class='form-control text-right'>
                                      </vue-autonumeric>
                                  </b-col>
                                </b-row>
                                <!--row-->
                                <b-row class="p-1">
                                  <b-col sm="6"  class="text-right p-1" >
                                    <label >FUNRURAL %</label>
                                  </b-col>
                                  <b-col sm="6">
                                    <vue-autonumeric  v-model="registro.dados.PERCENTUAL_FUNRURAL" 
                                                      :disabled="!formHabilitado"
                                                        :options="'percentageEU2decPos'"
                                                        class='form-control text-right'>
                                      </vue-autonumeric>
                                  </b-col>
                                </b-row>
                                <!--row-->
                                <b-row class="p-1">
                                  <b-col sm="6"  class="text-right p-1" >
                                    <label >FUNRURAL R$</label>
                                  </b-col>
                                  <b-col sm="6">
                                    <vue-autonumeric  v-model="registro.dados.VL_FUNRURAL" 
                                                      :disabled="true"
                                                        :options="{
                                                              digitGroupSeparator: '.',
                                                              decimalCharacter: ',',
                                                              decimalCharacterAlternative: '.',
                                                              decimalPlaces: '2',
                                                              roundingMethod: 'U',
                                                              minimumValue: '0'
                                                        }"
                                                        class='form-control text-right'>
                                      </vue-autonumeric>
                                  </b-col>
                                </b-row>
                                <!--row-->
                                <b-row class="p-1">
                                  <b-col sm="6"  class="text-right p-1" >
                                    <label >TOTAL COMPRA R$</label>
                                  </b-col>
                                  <b-col sm="6">
                                    <vue-autonumeric  v-model="registro.dados.VL_TOTAL_BRUTO" 
                                                      :disabled="true"
                                                        :options="{
                                                              digitGroupSeparator: '.',
                                                              decimalCharacter: ',',
                                                              decimalCharacterAlternative: '.',
                                                              decimalPlaces: '2',
                                                              roundingMethod: 'U',
                                                              minimumValue: '0'
                                                        }"
                                                        class='form-control text-right'>
                                      </vue-autonumeric>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <!--/.col-->
                                  <b-col sm="12" >
                                    <b-form-textarea
                                        id="edOBSERVACOES"
                                        placeholder="Observações"
                                        rows="5"
                                        max-rows="2">
                                    </b-form-textarea>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-card> 
                        </b-col>

                      </b-row>
                      
                    </b-col>
                    <!-- PARCELAMENTO -->
                    <b-col sm="4">
                      <b-card body-class="bg-gray-100">
                        <div slot="header">
                          <i class='fa fa-credit-card'></i> <strong>Parcelamento</strong>
                        </div>

                        <b-row>
                          <!--/.col-->
                          <b-col sm="5" >
                                <b-overlay  rounded="lg" opacity="0.6" >
                                    <template #overlay>
                                      <div class="d-flex align-items-center">
                                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                                        <b-spinner type="grow" variant="dark"></b-spinner>
                                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                                        <!-- We add an SR only text for screen readers -->
                                        <span class="sr-only">Aguarde...</span>
                                      </div>
                                    </template>
                                    <b-form-group
                                        id="lbVezes"
                                        label="Vezes"
                                        label-for="edVezes"
                                        valid-feedback="Gerado!"
                                      >
                                      <b-input-group>
                                          <vue-autonumeric  
                                            v-model="parcelamento.vezes" 
                                            :disabled="formHabilitado"
                                            :options="{
                                                  digitGroupSeparator: '.',
                                                  decimalCharacter: ',',
                                                  decimalCharacterAlternative: '.',
                                                  decimalPlaces: '0',
                                                  roundingMethod: 'U',
                                                  minimumValue: '0'
                                            }"
                                            :class="['form-control text-right',
                                                      {
                                                        'autonumeric_required': parcelamento.vezes == null,
                                                        'autonumeric_is-valid': parcelamento.vezes != null
                                                      }
                                                    ]">
                                          </vue-autonumeric>
                                          <b-input-group-append>
                                            <b-button 
                                                      @click.stop.prevent="gerarParcelamento()"
                                                      variant="primary"  
                                                      :disabled="formHabilitado"
                                                      >
                                              Parcelar
                                            </b-button>
                                        </b-input-group-append>                                    
                                      </b-input-group>
                                        
                                  </b-form-group>
                                </b-overlay>

                          </b-col>
                        </b-row>
                        <b-row>  
                            <!--/.col-->
                            <b-col sm="12" >
                              <b-table 
                                    striped 
                                    hover 
                                    :items="parcelamento.items" 
                                    :fields="parcelamento.campos"
                                    show-empty
                                    empty-text="Não existe parcelamento "
                                    stacked="md"
                                    
                                    small
                                    responsive 
                                    head-variant="dark"
                                    select-mode="single">
                                <template #cell(DT_VENCIMENTO)="item">
                                  <b-button type="button"  size="sm" variant="info" title="Alterar Vencimento" :disabled="formHabilitado" @click.stop.prevent="abrirModalVencimento(item.item)" v-b-tooltip.hover.left>
                                    <span>{{ converterDataVencimento(item.item.DT_VENCIMENTO) }}</span>
                                  <i class="fa fa-calendar"></i>
                                </b-button>
                                </template>      
                              </b-table>
                                  
                            </b-col>
                        </b-row>
                        
                        
                      </b-card>
                    </b-col>
                
                  </b-row>
              </div>
          </b-card>
          <!--/.row-->
          <b-card class="p-0">
            <b-row class="d-flex p-0">
              <b-button  
                    type="button"  
                    class="p-1 px-3 font-weight-bold ml-2" 
                    variant="info" 
                    @click="voltar()">
                  <i class="fa fa-arrow-left"></i> Voltar
              </b-button>
              <b-button  
                    v-if="habilitarBotaoGravar"
                    variant="success"
                    class="px-3 font-weight-bold ml-2"
                    :isLoading="isLoading" 
                    :disabled="isLoading"
                    :status="status"
                    
                    @click.stop.prevent="post()">
                  <i class="fa fa-save"></i> Gravar
              </b-button>   
              <b-button  v-if="habilitarBotaoReabrir"
                            variant="warning"  
                            ref="btReabrir"
                            class="px-3 font-weight-bold ml-2"
                            @click="abrirModalReabrir()">
                  <i class="fa fa-check"></i>  Reabrir
              </b-button>
              <b-button  
                    v-if="habilitarBotaoAlterar"
                    variant="success"
                    class="px-3 font-weight-bold ml-2"
                    :isLoading="isLoading" 
                    :disabled="isLoading"
                    :status="status"
                    
                    @click.stop.prevent="edit()">
                  <i class="fa fa-save"></i> Gravar Alterações
              </b-button>   
            </b-row>
          </b-card>
        
      <div>
        <!--  -----------------------------------------------------------------------------------
                                          MODAL REABRIR VENDA 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-reabrir" 
            id="modal-reabrir" 
            hide-header
            body-class="p-0"
            size="lg"
            @shown="focusModalReabrir()" 
            headerClass= "p-2 border-bottom-0" 
            title="REABRIR A COMPRA DE ANIMAIS" >
          
          <b-card bg-variant="light">
              <div slot="header">
                  <i class='fa fa-align-justify'></i><strong>  Reabrir a Compra de Animais</strong>
              </div>
               <b-row class="mb-1">
                
                <b-col >
                  <h5><strong>ID: {{registro.dados.ID}}</strong></h5>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col >
                  <h5><strong>{{registro.dados.ID_FORNECEDOR}} - {{ modalReabrir.nomeCliente }}</strong></h5>
                </b-col>
              </b-row>
              <hr>
              <b-row>  
                <b-col cols="12" md="3">
                  <label>Valor R$:</label>
                </b-col>
                <b-col cols="12" md="3">
                  <strong>{{registro.dados.VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</strong>
                </b-col>
              </b-row>
              <hr>
              <b-row class="mb-1">
                <b-col cols="12">
                    <label for="motivoCancelamento">Motivo para Reabrir</label>
                </b-col>
                <b-col cols="12" >
                  <b-form-input type="text" 
                                id="edMotivoReabrir" 
                                ref="edMotivoReabrir"
                                v-model="modalReabrir.motivo"
                                 :state="modalReabrir.motivo != null && modalReabrir.motivo != ''"  
                                placeholder="Informe o Motivo da reabertura" > 
                  </b-form-input>
                </b-col>
              </b-row>
          </b-card>

          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="reabrir()">
              REABRIR
            </b-button>
            <b-button    variant="danger" @click="cancel()">
              FECHAR
            </b-button>
          </template>
        </b-modal>
    </div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL VENCIMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-vencimento" 
          id="modal-vencimento" 
          hide-header
          body-class="p-0"
          size="lg"
          @shown="focusModalVencimento()" 
          headerClass= "p-2 border-bottom-0" 
          title="ALTERAR VENCIMENTO" >
        
        <b-card bg-variant="light">
            <div slot="header">
                <i class='fa fa-align-justify'></i><strong>  Alterar Vencimento</strong>
            </div>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Cliente:</label>
              </b-col>
              <b-col cols="12" md="8">
                <b-form-input  type="date" 
                                id="edParcelamentoDT_VENCIMENTO" 
                                ref="edParcelamentoDT_VENCIMENTO"
                                placeholder="Informe" 
                                v-model="parcelamento.itemEmAlteracao.DT_VENCIMENTO" 
                                :state="!!parcelamento.itemEmAlteracao.DT_VENCIMENTO">
                </b-form-input>
              </b-col>
            </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          
          <b-button variant="success" @click="cancel()">
            CONFIRMAR
          </b-button>
        </template>
      </b-modal>
    </div>        
    
     <!--  -----------------------------------------------------------------------------------
                                      MODAL PAGAMENTOS 
          ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-abate" 
            id="modal-abate" 
            no-close-on-esc 
            no-close-on-backdrop
            hide-header-close
            hide-header
            body-class="p-0"
            size="xl"
            headerClass= "p-2 border-bottom-0" 
            title="Lista de Abates em Aberto" >
         
          <b-card bg-variant="light">
              <div slot="header">
                  <i class='fa fa-align-justify'></i><strong>  Abates em Aberto</strong>
              </div>
                  
              <!--  -----------------------------------------------------------------------------------
                                          TABELA DE ABATE
                    ----------------------------------------------------------------------------------- -->
          
              <b-table  class="mb-0 table-outline" 
                    head-variant="dark"
                    show-empty
                    empty-text="Informe o filtro para ver os pesquisas "
                    stacked="md"
                    small
                    responsive 
                    striped 
                    hover 
                    select-mode="single"
                    selectable
                    :items="modalAbate.tabela.items" 
                    :fields="modalAbate.tabela.fields" 
                    :current-page="currentPage"
                    :per-page="perPage"
                    @row-clicked="selecionarAbate">
                  <template #cell(STATUS)="item" >
                    <div>
                      <b-badge :variant="variantStatus(item.item.OP_STATUS)">{{item.item.STATUS}}</b-badge>
                    </div>
                  </template>
                  <template #cell(TIPO_SERVICO_TRADUZIDO)="item" >
                    <div>
                      <b-badge :variant="variantServico(item.item.OP_TIPO_SERVICO)">{{item.item.TIPO_SERVICO_TRADUZIDO}}</b-badge>
                    </div>
                  </template>
              </b-table>
              <div class="justify-content-center row my-1">
                  <b-pagination size="md" :total-rows="modalAbate.tabela.items.length" :per-page="perPage" v-model="currentPage" />
            </div>
          </b-card>

          <template #modal-footer="{}">
              <b-button  variant="danger" @click="fecharModalAbate()">
                Fechar
              </b-button>
          </template>
              
        </b-modal>
    </div>
    
    
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import TransportadoraPesquisa from '../../pesquisa/TransportadoraPesquisa.vue'
import Tools from '../../../tools/tools'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'

export default {
  data () {
    return {
      teste: false,
      show: false,
      minimoMoeda: 0,
      overlayBaixando: false,
      overlayRecebimentos: false,
      submmited: false,
      desabilitado: false,
      parcelasVezes: [],
      controles: {
        falhaNaAbertura: false,
        emAlteracao: false,
      },
      dias: [],
      modalReabrir: {
        nomeCliente: null,
        motivo: null,
      },
      modalAbate: {
        parametros: {
          busy: false,
          overlay: false
        },
        tabela: {
          items: [],
          fields: [
            {
              key: "ID",
              label: 'Id'
            },
            {
              key: "STATUS",
              label: 'Status'
            },
            {
              key: "GTA",
              label: 'GTA'
            },
            {
              key: "TIPO_SERVICO_TRADUZIDO",
              label: 'Tipo'
            },
            {
              key: "DT_LOTE",
              label: 'Data',
              class:'text-right',
              formatter: (value, key, item) => 
                moment(value).format("DD/MM/YYYY")
            },
            {
              key: "BOI_PECAS",
              label: 'BOI',
              class:'text-right',
            },
            {
              key: "NOVILHA_PECAS",
              label: 'Novilha',
              class:'text-right',
            },
            {
              key: "TOURO_PECAS",
              label: 'Touro',
              class:'text-right',
            },
            {
              key: "ANIMAIS",
              label: 'Animais',
              class:'text-right',
            },
            {
              key: "QUANT",
              label: 'Peso KG',
              class:'text-right',
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal'})
            },
            {
              key: "MEDIA",
              label: 'Média KG',
              class:'text-right',
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal'})
            },
            {
              key: "NOME_FORNECEDOR",
              label: 'Fornecedor',
              formatter: (value, key, item) => 
                value.substr(0, 20)
            }
          ]
        }
      },
      registro: {
        info: {
          busy: false,
          gta: '',
          dataAbate: '',
          fornecedor: '',
          comprador: ''
        },
        dados: {
          ID: null,
          ID_FORNECEDOR: null,
          ID_CONFERENTE: null,
          DT_LANCAMENTO: null,
          DT_ABATE: null,
          ID_BALANCEIRO: null,
          ID_COMPRADOR: null,
          DT_CARREGAMENTO: null,
          DT_ALTERACAO: null,
          VL_LOTE: null,
          TX_MINUTA: null,
          OB_OBSERVACOES: null,
          OB_OBSERVACOES_LINHA: null,
          MOTIVO_REABRIR: null,
          VL_TOTAL_BATE: 0.00,
          ID_GRUPO_APAGAR: null,

          PARCELAS: 1,
          DIAS_ENTRE_PARCELAS: 0,

          NR_BOI4_PECAS: 0,
          NR_BOI4_PESO: 0.00,
          VL_BOI4_ARROBA: 0.00,
          NR_BOI4_TOTAL: 0.00,

          NR_BOI3_PECAS: 0,
          NR_BOI3_PESO: 0.00,
          VL_BOI3_ARROBA: 0.00,
          NR_BOI3_TOTAL: 0.00,

          NR_BOI2_PECAS: 0,
          NR_BOI2_PESO: 0.00,
          VL_BOI2_ARROBA: 0.00,
          NR_BOI2_TOTAL: 0.00,

          NR_BOI1_PECAS: 0,
          NR_BOI1_PESO: 0.00,
          VL_BOI1_ARROBA: 0.00,
          NR_BOI1_TOTAL: 0.00,
          
          NR_BOI0_PECAS: 0,
          NR_BOI0_PESO: 0.00,
          VL_BOI0_ARROBA: 0.00,
          NR_BOI0_TOTAL: 0.00,
          
          NR_BOI4_PECAS: 0,
          NR_BOI4_PESO: 0.00,
          VL_BOI4_ARROBA: 0.00,
          NR_BOI4_TOTAL: 0.00,

          NR_BOI3_PESO: 0.00,
          NR_BOI3_PECAS: 0,
          VL_BOI3_ARROBA: 0.00,
          NR_BOI3_TOTAL: 0.00,

          NR_BOI2_PESO: 0.00,
          NR_BOI2_PECAS: 0,
          VL_BOI2_ARROBA: 0.00,
          NR_BOI2_TOTAL: 0.00,

          NR_BOI0_PECAS: 0,
          NR_BOI0_PESO: 0.00,
          VL_BOI0_ARROBA: 0.00,
          NR_BOI0_TOTAL: 0.00,
          
          NR_BOI1_PESO: 0.00,
          NR_BOI1_PECAS: 0,
          VL_BOI1_ARROBA: 0.00,
          NR_BOI1_TOTAL: 0.00,

          NR_TOURO4_PECAS: 0,
          NR_TOURO4_PESO: 0.00,
          VL_TOURO4_ARROBA: 0.00,
          NR_TOURO4_TOTAL: 0.00,

          NR_TOURO3_PECAS: 0,
          NR_TOURO3_PESO: 0.00,
          VL_TOURO3_ARROBA: 0.00,
          NR_TOURO3_TOTAL: 0.00,

          NR_TOURO2_PECAS: 0,
          NR_TOURO2_PESO: 0.00,
          VL_TOURO2_ARROBA: 0.00,
          NR_TOURO2_TOTAL: 0.00,

          NR_TOURO1_PECAS: 0,
          NR_TOURO1_PESO: 0.00,
          VL_TOURO1_ARROBA: 0.00,
          NR_TOURO1_TOTAL: 0.00,

          NR_TOURO0_PECAS: 0,
          NR_TOURO0_PESO: 0.00,
          VL_TOURO0_ARROBA: 0.00,
          NR_TOURO0_TOTAL: 0.00,
          
          NR_NOVILHA4_PECAS: 0,
          NR_NOVILHA4_PESO: 0.00,
          VL_NOVILHA4_ARROBA: 0.00,
          NR_NOVILHA4_TOTAL: 0.00,

          NR_NOVILHA3_PECAS: 0,
          NR_NOVILHA3_PESO: 0.00,
          VL_NOVILHA3_ARROBA: 0.00,
          NR_NOVILHA3_TOTAL: 0.00,

          NR_NOVILHA2_PECAS: 0,
          NR_NOVILHA2_PESO: 0.00,
          VL_NOVILHA2_ARROBA: 0.00,
          NR_NOVILHA2_TOTAL: 0.00,

          NR_NOVILHA1_PECAS: 0,
          NR_NOVILHA1_PESO: 0.00,
          VL_NOVILHA1_ARROBA: 0.00,
          NR_NOVILHA1_TOTAL: 0.00,
          
          NR_NOVILHA0_PECAS: 0,
          NR_NOVILHA0_PESO: 0.00,
          VL_NOVILHA0_ARROBA: 0.00,
          NR_NOVILHA0_TOTAL: 0.00,

          //BOI CAPAO
          NR_BOI_CAPAO4_PECAS: 0,
          NR_BOI_CAPAO4_PESO: 0.00,
          VL_BOI_CAPAO4_ARROBA: 0.00,
          NR_BOI_CAPAO4_TOTAL: 0.00,

          NR_BOI_CAPAO3_PECAS: 0,
          NR_BOI_CAPAO3_PESO: 0.00,
          VL_BOI_CAPAO3_ARROBA: 0.00,
          NR_BOI_CAPAO3_TOTAL: 0.00,

          NR_BOI_CAPAO2_PECAS: 0,
          NR_BOI_CAPAO2_PESO: 0.00,
          VL_BOI_CAPAO2_ARROBA: 0.00,
          NR_BOI_CAPAO2_TOTAL: 0.00,

          NR_BOI_CAPAO1_PECAS: 0,
          NR_BOI_CAPAO1_PESO: 0.00,
          VL_BOI_CAPAO1_ARROBA: 0.00,
          NR_BOI_CAPAO1_TOTAL: 0.00,
          
          NR_BOI_CAPAO0_PECAS: 0,
          NR_BOI_CAPAO0_PESO: 0.00,
          VL_BOI_CAPAO0_ARROBA: 0.00,
          NR_BOI_CAPAO0_TOTAL: 0.00,

          //BUFALO MACHO
          NR_BUFALO_MACHO4_PECAS: 0,
          NR_BUFALO_MACHO4_PESO: 0.00,
          VL_BUFALO_MACHO4_ARROBA: 0.00,
          NR_BUFALO_MACHO4_TOTAL: 0.00,

          NR_BUFALO_MACHO3_PECAS: 0,
          NR_BUFALO_MACHO3_PESO: 0.00,
          VL_BUFALO_MACHO3_ARROBA: 0.00,
          NR_BUFALO_MACHO3_TOTAL: 0.00,

          NR_BUFALO_MACHO2_PECAS: 0,
          NR_BUFALO_MACHO2_PESO: 0.00,
          VL_BUFALO_MACHO2_ARROBA: 0.00,
          NR_BUFALO_MACHO2_TOTAL: 0.00,

          NR_BUFALO_MACHO1_PECAS: 0,
          NR_BUFALO_MACHO1_PESO: 0.00,
          VL_BUFALO_MACHO1_ARROBA: 0.00,
          NR_BUFALO_MACHO1_TOTAL: 0.00,
          
          NR_BUFALO_MACHO0_PECAS: 0,
          NR_BUFALO_MACHO0_PESO: 0.00,
          VL_BUFALO_MACHO0_ARROBA: 0.00,
          NR_BUFALO_MACHO0_TOTAL: 0.00,

          //BUFALO FEMEA
          NR_BUFALO_FEMEA4_PECAS: 0,
          NR_BUFALO_FEMEA4_PESO: 0.00,
          VL_BUFALO_FEMEA4_ARROBA: 0.00,
          NR_BUFALO_FEMEA4_TOTAL: 0.00,

          NR_BUFALO_FEMEA3_PECAS: 0,
          NR_BUFALO_FEMEA3_PESO: 0.00,
          VL_BUFALO_FEMEA3_ARROBA: 0.00,
          NR_BUFALO_FEMEA3_TOTAL: 0.00,

          NR_BUFALO_FEMEA2_PECAS: 0,
          NR_BUFALO_FEMEA2_PESO: 0.00,
          VL_BUFALO_FEMEA2_ARROBA: 0.00,
          NR_BUFALO_FEMEA2_TOTAL: 0.00,

          NR_BUFALO_FEMEA1_PECAS: 0,
          NR_BUFALO_FEMEA1_PESO: 0.00,
          VL_BUFALO_FEMEA1_ARROBA: 0.00,
          NR_BUFALO_FEMEA1_TOTAL: 0.00,
          
          NR_BUFALO_FEMEA0_PECAS: 0,
          NR_BUFALO_FEMEA0_PESO: 0.00,
          VL_BUFALO_FEMEA0_ARROBA: 0.00,
          NR_BUFALO_FEMEA0_TOTAL: 0.00,
          
          DT_VENCIMENTO: null,
          OP_STATUS: '1',
          VL_FRETE: null,
          TX_PLACA: null,
          QUANT_BANDAS: null,
          PECAS_BANDA: null,
          DT_LANCA_BANDA: null,
          USUARIO_LANCA_BANDA: null,
          OP_BANDAS: null,
          PERCENTUAL_FUNRURAL: null,
          VL_FUNRURAL: 0.00,
          VL_TOTAL_BRUTO: 0.00,
          CENTRO_ESTOQUE_ID: null,
          TRANSPORTADORA_ID: null,
          OP_TIPO_DOCUMENTO: null,
          DOCUMENTO: null,
          GTA: null,
          DT_CANCELAMENTO: null,
          USUARIO_CANCELAMENTO: null,
          MOTIVO_CANCELAMENTO: null,
          MARCHANT_ID: null,
          FAZENDA_ID: null,
          BALANCEIRO_ID: null,
          MOTORISTA_ID: null,
          NR_BOI_PECAS_TOTAL: 0,
          NR_BOI_PECAS_TOTAL: 0,
          NR_TOURO_PECAS_TOTAL: 0,
          NR_NOVILHA_PECAS_TOTAL: 0,
          NR_BOI_CAPAO_PECAS_TOTAL: 0,
          NR_BUFALO_MACHO_PECAS_TOTAL: 0,
          NR_BUFALO_FEMEA_PECAS_TOTAL: 0,
          OP_GERA_APAGAR: 0,
          NR_BOI_PESO_TOTAL: 0,
          NR_NOVILHA_PESO_TOTAL: 0,
          NR_BOI_PESO_TOTAL: 0,
          NR_TOURO_PESO_TOTAL: 0,
          NR_BOI_CAPAO_PESO_TOTAL: 0,
          NR_BUFALO_MACHO_PESO_TOTAL: 0,
          NR_BUFALO_FEMEA_PESO_TOTAL: 0,
          ABATE_ID: null,
          OP_ABATIDO: null
        }
      },
      parcelamento: {
        vezes: 0,
        itemEmAlteracao: {},
        template: {
              ID: null,
              DOCUMENTO: null,
              PARCELA: null,
              DT_VENCIMENTO: null,
              VL_PARCELA: null,
              VL_JUROS: null,
              COMPRA_GADO_ID: null
        },
        campos: [
          {
            key: "PARCELA",
            label: 'Parcela',
            class:'text-center' 
          },
          {
            key: 'DT_VENCIMENTO',
            label: 'Vencimento',
            class:'text-center', 
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: 'VL_PARCELA', 
            class:'text-right', 
            label: 'Valor (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          }
        ],
        items: []
      },
      animais: {
        BOI:{
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        boi: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        touro: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        novilha: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        boicapao: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        bufalomacho: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        },
        bufalofemea: {
          id: null,
          faixa4: {
            media: 0
          },
          faixa3: {
            media: 0
          },
          faixa2: {
            media: 0
          },
          faixa1: {
            media: 0
          },
          faixa0: {
            media: 0
          }
        }
        
      },
      formatoPeso: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      formatoPecas: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      pesquisa: {
        abateId: '',
        documento: '',
        situacao: '1',
        cliente_id: null,
        vendedor_id: null,
        dt1: new Date().toJSON().slice(0, 10),
        dt2: new Date().toJSON().slice(0, 10)
      },
      isLoading: false,
      status: '',
      isBusyListagem: false,
      items: [],
      fields: [
        {
          key: "DOCUMENTO",
          label: 'Documento',
          sortable: true
        },
        {
          key: "PARCELA",
          label: 'Parc.',
          sortable: true 
        },
        {
          key: "ITENS",
          label: 'Descrição',
          sortable: true 
        },
        {
          key: "NOME_CLIENTE",
          label: 'Cliente',
          sortable: true 
        },
        {
          key: "DT_DOC",
          label: 'Data. Docto.', 
          sortable: true,
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "DT_RECEB",
          label: 'Vencimento', 
          sortable: true,
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "DIAS_ATRASO",
          label: 'Atrazo',
          sortable: true 
        },
        {
          key: 'VL_DOC', 
          class:'text-right', 
          label: 'Original (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_ARECEBER', 
          class:'text-right', 
          label: 'Restante (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right' 
        }
      ],
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      filter: null
    }
  },
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    FuncionarioPesquisa,
    TransportadoraPesquisa,
    VueAutonumeric
  },
  computed: {
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    formHabilitado(){
      return this.registro.dados.OP_STATUS != '1'
    },
    habilitarBotaoReabrir() {
      return ((this.registro.dados.OP_STATUS === '2') && (this.controles.falhaNaAbertura == false) )
    },
    habilitarBotaoGravar() {
      
      return (this.controles.falhaNaAbertura == false) &&
             (this.controles.emAlteracao == false) &&
             (this.registro.dados.OP_STATUS === '1')
    },
    habilitarBotaoAlterar() {
      return (this.controles.falhaNaAbertura == false) &&
             (this.controles.emAlteracao == true) &&
             (this.registro.dados.OP_STATUS === '1')
    },
    validouVL_TOTAL_BRUTO(){
      return ((this.registro.dados.VL_TOTAL_BRUTO ) && (this.registro.dados.VL_TOTAL_BRUTO > 0)) ? true : false
    },
    valID_COMPRADOR(){
      return ((this.registro.dados.ID_COMPRADOR ) && (this.registro.dados.ID_COMPRADOR > 0)) ? true : false
    },
    validouDT_VENCIMENTO () {
      return (this.registro.dados.DT_VENCIMENTO !== null && this.registro.dados.DT_VENCIMENTO !== '')
    },
    validouNR_BOI4_TOTAL() {
     return (this.registro.dados.NR_BOI4_PESO > 0.00) ? (this.registro.dados.NR_BOI4_TOTAL > 0.00) : true
    },
    validouNR_BOI3_TOTAL() {
     return (this.registro.dados.NR_BOI3_PESO > 0.00) ? (this.registro.dados.NR_BOI3_TOTAL > 0.00) : true
    },
    validouNR_BOI2_TOTAL() {
     return (this.registro.dados.NR_BOI2_PESO > 0.00) ? (this.registro.dados.NR_BOI2_TOTAL > 0.00) : true
    },
    validouNR_BOI1_TOTAL() {
     return (this.registro.dados.NR_BOI1_PESO > 0.00) ? (this.registro.dados.NR_BOI1_TOTAL > 0.00) : true
    },
    validouNR_BOI0_TOTAL() {
     return (this.registro.dados.NR_BOI0_PESO > 0.00) ? (this.registro.dados.NR_BOI0_TOTAL > 0.00) : true
    },
    validouNR_BOI4_TOTAL() {
     return (this.registro.dados.NR_BOI4_PESO > 0.00) ? (this.registro.dados.NR_BOI4_TOTAL > 0.00) : true
    },
    validouNR_BOI3_TOTAL() {
     return (this.registro.dados.NR_BOI3_PESO > 0.00) ? (this.registro.dados.NR_BOI3_TOTAL > 0.00) : true
    },
    validouNR_BOI2_TOTAL() {
     return (this.registro.dados.NR_BOI2_PESO > 0.00) ? (this.registro.dados.NR_BOI2_TOTAL > 0.00) : true
    },
    validouNR_BOI1_TOTAL() {
     return (this.registro.dados.NR_BOI1_PESO > 0.00) ? (this.registro.dados.NR_BOI1_TOTAL > 0.00) : true
    },
    validouNR_BOI0_TOTAL() {
     return (this.registro.dados.NR_BOI0_PESO > 0.00) ? (this.registro.dados.NR_BOI0_TOTAL > 0.00) : true
    },
    validouNR_TOURO4_TOTAL() {
     return (this.registro.dados.NR_TOURO4_PESO > 0.00) ? (this.registro.dados.NR_TOURO4_TOTAL > 0.00) : true
    },
    validouNR_TOURO3_TOTAL() {
     return (this.registro.dados.NR_TOURO3_PESO > 0.00) ? (this.registro.dados.NR_TOURO3_TOTAL > 0.00) : true
    },
    validouNR_TOURO2_TOTAL() {
     return (this.registro.dados.NR_TOURO2_PESO > 0.00) ? (this.registro.dados.NR_TOURO2_TOTAL > 0.00) : true
    },
    validouNR_TOURO1_TOTAL() {
     return (this.registro.dados.NR_TOURO1_PESO > 0.00) ? (this.registro.dados.NR_TOURO1_TOTAL > 0.00) : true
    },
    validouNR_TOURO0_TOTAL() {
     return (this.registro.dados.NR_TOURO0_PESO > 0.00) ? (this.registro.dados.NR_TOURO0_TOTAL > 0.00) : true
    },
    validouNR_NOVILHA4_TOTAL() {
     return (this.registro.dados.NR_NOVILHA4_PESO > 0.00) ? (this.registro.dados.NR_NOVILHA4_TOTAL > 0.00) : true
    },
    validouNR_NOVILHA3_TOTAL() {
     return (this.registro.dados.NR_NOVILHA3_PESO > 0.00) ? (this.registro.dados.NR_NOVILHA3_TOTAL > 0.00) : true
    },
    validouNR_NOVILHA2_TOTAL() {
     return (this.registro.dados.NR_NOVILHA2_PESO > 0.00) ? (this.registro.dados.NR_NOVILHA2_TOTAL > 0.00) : true
    },
    validouNR_NOVILHA1_TOTAL() {
     return (this.registro.dados.NR_NOVILHA1_PESO > 0.00) ? (this.registro.dados.NR_NOVILHA1_TOTAL > 0.00) : true
    },
    validouNR_NOVILHA0_TOTAL() {
     return (this.registro.dados.NR_NOVILHA0_PESO > 0.00) ? (this.registro.dados.NR_NOVILHA0_TOTAL > 0.00) : true
    },
    validouNR_BOI_CAPAO4_TOTAL() {
     return (this.registro.dados.NR_BOI_CAPAO4_PESO > 0.00) ? (this.registro.dados.NR_BOI_CAPAO4_TOTAL > 0.00) : true
    },
    validouNR_BOI_CAPAO3_TOTAL() {
     return (this.registro.dados.NR_BOI_CAPAO3_PESO > 0.00) ? (this.registro.dados.NR_BOI_CAPAO3_TOTAL > 0.00) : true
    },
    validouNR_BOI_CAPAO2_TOTAL() {
     return (this.registro.dados.NR_BOI_CAPAO2_PESO > 0.00) ? (this.registro.dados.NR_BOI_CAPAO2_TOTAL > 0.00) : true
    },
    validouNR_BOI_CAPAO1_TOTAL() {
     return (this.registro.dados.NR_BOI_CAPAO1_PESO > 0.00) ? (this.registro.dados.NR_BOI_CAPAO1_TOTAL > 0.00) : true
    },
    validouNR_BOI_CAPAO0_TOTAL() {
     return (this.registro.dados.NR_BOI_CAPAO0_PESO > 0.00) ? (this.registro.dados.NR_BOI_CAPAO0_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_MACHO4_TOTAL() {
     return (this.registro.dados.BUFALO_MACHO4_PESO > 0.00) ? (this.registro.dados.BUFALO_MACHO4_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_MACHO3_TOTAL() {
     return (this.registro.dados.BUFALO_MACHO3_PESO > 0.00) ? (this.registro.dados.BUFALO_MACHO3_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_MACHO2_TOTAL() {
     return (this.registro.dados.BUFALO_MACHO2_PESO > 0.00) ? (this.registro.dados.BUFALO_MACHO2_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_MACHO1_TOTAL() {
     return (this.registro.dados.BUFALO_MACHO1_PESO > 0.00) ? (this.registro.dados.BUFALO_MACHO1_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_MACHO0_TOTAL() {
     return (this.registro.dados.BUFALO_MACHO0_PESO > 0.00) ? (this.registro.dados.BUFALO_MACHO0_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_FEMEA4_TOTAL() {
     return (this.registro.dados.BUFALO_FEMEA4_PESO > 0.00) ? (this.registro.dados.BUFALO_FEMEA4_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_FEMEA3_TOTAL() {
     return (this.registro.dados.BUFALO_FEMEA3_PESO > 0.00) ? (this.registro.dados.BUFALO_FEMEA3_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_FEMEA2_TOTAL() {
     return (this.registro.dados.BUFALO_FEMEA2_PESO > 0.00) ? (this.registro.dados.BUFALO_FEMEA2_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_FEMEA1_TOTAL() {
     return (this.registro.dados.BUFALO_FEMEA1_PESO > 0.00) ? (this.registro.dados.BUFALO_FEMEA1_TOTAL > 0.00) : true
    },
    validouNR_BUFALO_FEMEA0_TOTAL() {
     return (this.registro.dados.BUFALO_FEMEA0_PESO > 0.00) ? (this.registro.dados.BUFALO_FEMEA0_TOTAL > 0.00) : true
    }
    
    
  },
  methods: {
    voltar() {
      Tools.voltar(this)
    },
    traduzirSituacao(value) {
      switch (value) {
        case '0':
          return 'CANCELADO'
        case '1':
          return 'CADASTRANDO'
        case '2':
          return 'FECHADO'
        default:
          return ''
      }
    },
    async abrirModalReabrir() {
      try {
        
        this.$store.commit('controle/setAguardando', true)
        this.modalReabrir.nomeCliente = this.$refs.edID_FORNECEDOR.$refs.auto.$refs.autocomplete._value
        this.modalReabrir.motivo = null
        //this.venda.OBS3 = null
        this.$refs['modal-reabrir'].show()

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async reabrir() {
      if (!this.modalReabrir.motivo) {
        this.toastCount++
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Motivo' )
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          const body = {
            id: this.registro.dados.ID,
            login: window.localStorage.getItem('login'),
            motivo: this.modalReabrir.motivo
          }
          
          await this.$http.post(`/api/protected/compragado/reabrir`, body)
          
          const compraGadoResult = await this.$http.get( `/api/protected/compragado/getById/${this.registro.dados.ID}`)

          let compraGadoAux = compraGadoResult.data?.[0]
          this.ajustarCamposRegistro(compraGadoAux)
          
          this.registro.dados = compraGadoAux

          this.controles.emAlteracao = true
          this.controles.falhaNaAbertura = false
          
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Reaberta com Sucesso!' )
          this.$refs['modal-reabrir'].hide()

        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Tente novamente' )
          return
        }

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        
      
    },
    focusModalReabrir(){
        this.$refs.edMotivoReabrir.focus()
    },
    abrirModalVencimento(item) {
      this.parcelamento.itemEmAlteracao = item
      Tools.formatarDataParaInput(this.parcelamento.itemEmAlteracao.DT_VENCIMENTO)
      this.$refs['modal-vencimento'].show()      
    },
    focusModalVencimento() {
      this.$nextTick(() => {
          this.$refs.edParcelamentoDT_VENCIMENTO.focus()
      })
    },
    converterDataVencimento(data) {
      return Tools.formatarDataBR(data)
    },
    gerarParcelamento() {
      if ( this.registro.dados.VL_TOTAL_BATE === null  || this.registro.dados.VL_TOTAL_BATE === ''  || this.registro.dados.VL_TOTAL_BATE <= 0.00) {
        this.parcelamento.items = []
        return
      }

      const total = parseFloat(this.registro.dados.VL_TOTAL_BATE)
      const parcelas = parseInt(this.parcelamento.vezes)
      const dataInicial = this.registro.dados.DT_ABATE 
                        ? moment(this.registro.dados.DT_ABATE)
                        : moment() // fallback para hoje
      
      this.parcelamento.items = []

      // PAGAMENTO À VISTA
      if (parcelas === 0) {
        this.parcelamento.items.push({
          ID: -1,
          COMPRA_GADO_ID: this.registro.dados.ID,
          PARCELA : 1,
          DT_VENCIMENTO : dataInicial.format('YYYY-MM-DD'),
          VL_PARCELA : parseFloat(total.toFixed(2)),
          VL_JUROS : 0.00
        })
        return
      }
      
      // PAGAMENTO A PRAZO
      let valorParcela = parseFloat((total / parcelas).toFixed(2))
      let somaParcelas = parseFloat((valorParcela * parcelas).toFixed(2))
      let diferenca = parseFloat((total - somaParcelas).toFixed(2))
      let valorUltimaParcela = parseFloat((valorParcela + diferenca).toFixed(2))

      for (let i = 0; i < parcelas; i++) {
        let vencimento

        vencimento = moment(dataInicial).add(i, 'months')

        this.parcelamento.items.push({
          ID: -1,
          COMPRA_GADO_ID: this.registro.dados.ID,
          PARCELA : i + 1,
          DT_VENCIMENTO : vencimento.format('YYYY-MM-DD'),
          VL_PARCELA : i === parcelas - 1 ? valorUltimaParcela : valorParcela,
          VL_JUROS : 0.00
        })
      }

    },
    rowClassListagem(item, type) {
      if (item && type === 'row') {
        if ((item.SITUACAO_TRADUZIDO) && (item.SITUACAO_TRADUZIDO.trim() === 'CANCELADO')) {
          return 'text-danger'
        } else {
          return null
        } 
      } else {
        return null
      }
    },
    variantStatus (value) {
      let $variant
      if (value === '4') {
        $variant = 'info'
      } else if (value === '5') {
        $variant = 'success'
      } else if (value === '6') {
        $variant = 'warning'
      } else if (value === '0') {
        $variant = 'danger'
      }
      return $variant
    },
    variantServico (value) {
      let $variant
      if (value === '0' || value === 0) {
        $variant = 'secondary'
      } else if (value === '1' || value === 1) {
        $variant = 'secondary'
      } else if (value === '2' || value === 2 ) {
        $variant = 'primary'
      } 
      return $variant
    },
    validouForm() {
      return     this.registro.dados.ID_COMPRADOR 
              && this.registro.dados.DT_VENCIMENTO
              && this.registro.dados.ID_FORNECEDOR
              && this.registro.dados.GTA
              && this.registro.dados.TX_MINUTA
              && this.validouVL_TOTAL_BRUTO
              /*
              && this.validouDT_VENCIMENTO  
              && this.validouNR_BOI4_TOTAL 
              && this.validouNR_BOI3_TOTAL 
              && this.validouNR_BOI2_TOTAL 
              && this.validouNR_BOI1_TOTAL 
              && this.validouNR_BOI0_TOTAL 
              && this.validouNR_BOI4_TOTAL 
              && this.validouNR_BOI3_TOTAL 
              && this.validouNR_BOI2_TOTAL 
              && this.validouNR_BOI1_TOTAL 
              && this.validouNR_BOI0_TOTAL 
              && this.validouNR_TOURO4_TOTAL 
              && this.validouNR_TOURO3_TOTAL 
              && this.validouNR_TOURO2_TOTAL 
              && this.validouNR_TOURO1_TOTAL 
              && this.validouNR_TOURO0_TOTAL 
              && this.validouNR_NOVILHA4_TOTAL 
              && this.validouNR_NOVILHA3_TOTAL 
              && this.validouNR_NOVILHA2_TOTAL 
              && this.validouNR_NOVILHA1_TOTAL 
              && this.validouNR_NOVILHA0_TOTAL 
              && this.validouNR_BOI_CAPAO4_TOTAL 
              && this.validouNR_BOI_CAPAO3_TOTAL 
              && this.validouNR_BOI_CAPAO2_TOTAL 
              && this.validouNR_BOI_CAPAO1_TOTAL 
              && this.validouNR_BOI_CAPAO0_TOTAL 
              && this.validouNR_BUFALO_MACHO4_TOTAL 
              && this.validouNR_BUFALO_MACHO3_TOTAL 
              && this.validouNR_BUFALO_MACHO2_TOTAL 
              && this.validouNR_BUFALO_MACHO1_TOTAL 
              && this.validouNR_BUFALO_MACHO0_TOTAL
              && this.validouNR_BUFALO_FEMEA4_TOTAL 
              && this.validouNR_BUFALO_FEMEA3_TOTAL 
              && this.validouNR_BUFALO_FEMEA2_TOTAL 
              && this.validouNR_BUFALO_FEMEA1_TOTAL 
              && this.validouNR_BUFALO_FEMEA0_TOTAL  */
    },
    async imprimir (id, valor) {
      this.isLoading = true
      this.submmited = true
      let usuario = window.localStorage.getItem('login')
      let uri = `/api/protected/relatorios/relCompraGadoEspelhoAssinatura?id=${id}&valor=${valor}&usuario=${usuario}`
      return this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.isLoading = false
          this.submmited = false
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relCompraGadoEspelhoAssinatura.pdf')
          link.download = 'relCompraGadoEspelhoAssinatura.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Romaneio de Compra de Gado'
            }, 2000);
          }
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.isLoading = false
        })
    },
    async post() {
      try {
        
        if (!this.validouForm()) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Aviso!!! Preencha todas as informaçãoes` )
          return
        }

        this.$store.commit('controle/setAguardando', true)


        let pacote = { 
          login: window.localStorage.getItem('login'),
          compraGado: this.registro.dados,
          parcelamento : this.parcelamento.items
        }

        let responseAux = null
        try {
          responseAux = await this.$http.post('/api/protected/compragado/post', pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        let retornoId = responseAux.data?.id?? null
        if (!retornoId) {

          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponivel. Tenta novamente!' )
          return
        }

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Aviso!!! Registro gravado com sucesso!!` )
        
        const imprimir = await this.$bvModal.msgBoxConfirm('Você quer imprimir o resumo do compra?.', {
          title: 'Selecine o opção',
          size: 'sm',
          buttonSize: 'lg',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (imprimir == true) {
          await this.imprimir(retornoId, this.registro.dados.VL_TOTAL_BRUTO)
        }

        this.$store.commit("compraGado/SET_REGISTRO_SELECIONADO_ID", retornoId)
        this.voltar()
      } finally {
        
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async edit() {
      try {
        
        if (!this.validouForm()) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Aviso!!! Preencha todas as informaçãoes` )
          return
        }

        this.$store.commit('controle/setAguardando', true)

        let pacote = { 
          login: window.localStorage.getItem('login'),
          dados: this.registro.dados,
          parcelamento : this.parcelamento.items
        }

        let responseAux = null
        try {
          responseAux = await this.$http.post('/api/protected/compragado/edit', pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Aviso!!! Registro gravado com sucesso!!` )
        
        const imprimir = await this.$bvModal.msgBoxConfirm('Você quer imprimir o resumo do compra?.', {
          title: 'Selecine o opção',
          size: 'sm',
          buttonSize: 'lg',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (imprimir == true) {
          await this.imprimir(this.registro.dados.ID, this.registro.dados.VL_TOTAL_BRUTO)
        }
        this.voltar()
      } finally {
        
        this.$store.commit('controle/setAguardando', false)
      }
    },
    fecharModalAbate() {
      this.modalAbate.parametros.busy = false
      this.$refs['modal-abate'].hide()
    },
    abrirModalAbate() {
      this.modalAbate.parametros.busy = true
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producao/listarordensencerradas`)
      return this.$http.get(uri).then((data) => {
        if (data) {
          this.modalAbate.tabela.items = data.data
        }        
      })
      .then(() => {
        this.$refs['modal-abate'].show()
        return
      })
      .catch((error) => {
        this.modalAbate.parametros.busy = false
        if (error) {
          this.$root.$bvToast.toast(`Falha!!!  Não foi Possível localizar os abates fechados`, {
            title: 'Falha',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        }
      })
    },
    selecionarAbate(abate) {
      this.zerarAnimais()
      this.registro.dados.ABATE_ID = abate.ID
      this.registro.dados.ID_FORNECEDOR = abate.CLIENTE_ID
      this.registro.dados.DT_ABATE = abate.DT_LOTE
      this.registro.info.fornecedor = abate.NOME_FORNECEDOR
      this.registro.info.gta = abate.GTA
      this.registro.info.dataAbate = moment(abate.DT_LOTE).format("DD/MM/YYYY")
      
      let uri = this.$http.defaults.baseURL.concat('api/protected/parametro/getanimais')
      return this.$http.get(uri)
      .then((data) => {
        if (data) {
          this.animais.boi.id = data.data[0].BOI_ID
          this.animais.BOI.id = data.data[0].BOI_ID
          this.animais.touro.id = data.data[0].TOURO_ID
          this.animais.novilha.id = data.data[0].NOVILHA_ID
          this.animais.boicapao.id = data.data[0].BOI_CAPAO_ID
          this.animais.bufalomacho.id = data.data[0].BUFALO_MACHO_ID
          this.animais.bufalofemea.id = data.data[0].BUFALO_FEMEA_ID
          return true
        }
      })
      .then((ok) => {
        let id = this.registro.dados.ABATE_ID
        uri = this.$http.defaults.baseURL.concat(`api/protected/compragado/listarclassificacaoabate?id=${id}`)
        return this.$http.get(uri)
        .then((data) => {
          if (data) {
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].PRODUTO_ID === this.animais.boi.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_BOI4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_BOI3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_BOI2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_BOI1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_BOI0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI0_PECAS = data.data[i].PECAS
                }
              }
              else if (data.data[i].PRODUTO_ID === this.animais.BOI.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_BOI4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_BOI3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_BOI2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_BOI1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_BOI0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI0_PECAS = data.data[i].PECAS
                }
              }
               else if (data.data[i].PRODUTO_ID === this.animais.touro.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_TOURO4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_TOURO4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_TOURO3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_TOURO3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_TOURO2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_TOURO2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_TOURO1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_TOURO1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_TOURO0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_TOURO0_PECAS = data.data[i].PECAS
                }
              } else if (data.data[i].PRODUTO_ID === this.animais.novilha.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_NOVILHA4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_NOVILHA4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_NOVILHA3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_NOVILHA3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_NOVILHA2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_NOVILHA2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_NOVILHA1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_NOVILHA1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_NOVILHA0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_NOVILHA0_PECAS = data.data[i].PECAS
                }
              } else if (data.data[i].PRODUTO_ID === this.animais.boicapao.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_BOI_CAPAO4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI_CAPAO4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_BOI_CAPAO3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI_CAPAO3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_BOI_CAPAO2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI_CAPAO2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_BOI_CAPAO1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI_CAPAO1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_BOI_CAPAO0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BOI_CAPAO0_PECAS = data.data[i].PECAS
                }
              } else if (data.data[i].PRODUTO_ID === this.animais.bufalomacho.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_BUFALO_MACHO4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_MACHO4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_BUFALO_MACHO3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_MACHO3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_BUFALO_MACHO2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_MACHO2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_BUFALO_MACHO1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_MACHO1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_BUFALO_MACHO0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_MACHO0_PECAS = data.data[i].PECAS
                }
              } else if (data.data[i].PRODUTO_ID === this.animais.bufalofemea.id) {
                if (data.data[i].FAIXA === 4) {
                  this.registro.dados.NR_BUFALO_FEMEA4_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_FEMEA4_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 3) {
                  this.registro.dados.NR_BUFALO_FEMEA3_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_FEMEA3_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 2) {
                  this.registro.dados.NR_BUFALO_FEMEA2_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_FEMEA2_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 1) {
                  this.registro.dados.NR_BUFALO_FEMEA1_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_FEMEA1_PECAS = data.data[i].PECAS
                } else if (data.data[i].FAIXA === 0) {
                  this.registro.dados.NR_BUFALO_FEMEA0_PESO = data.data[i].QUANT
                  this.registro.dados.NR_BUFALO_FEMEA0_PECAS = data.data[i].PECAS
                }
              }
            }
            this.$refs['modal-abate'].hide()
            this.modalAbate.parametros.busy = false
          } else {
            this.$refs['modal-abate'].hide()
            this.modalAbate.parametros.busy = false
          }
        })
      }).catch((error) => {
        if (error) {
          this.$root.$bvToast.toast(`Falha ao consultar os parametros!!!`, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
        }
      this.$refs['modal-abate'].hide()
      this.modalAbate.parametros.busy = false
      })

    },
    async abrirCompraGado(compraGadoId) {
      let parametrosResult = null
      try {
        parametrosResult = await this.$http.get('/api/protected/parametro/getanimais')
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler os parametros do sistema!' )
        this.controles.falhaNaAbertura = true
      }
      let data = parametrosResult.data?.[0]
      if (!data) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler os parametros do sistema!' )
        this.controles.falhaNaAbertura = true
      }
      
      this.animais.boi.id = data.BOI_ID
      this.animais.BOI.id = data.BOI_ID
      this.animais.touro.id = data.TOURO_ID
      this.animais.novilha.id = data.NOVILHA_ID
      this.animais.boicapao.id = data.BOI_CAPAO_ID
      this.animais.bufalomacho.id = data.BUFALO_MACHO_ID
      this.animais.bufalofemea.id = data.BUFALO_FEMEA_ID
      
      this.zerarAnimais()

      let compraGadoResult = null
      try {
        compraGadoResult = await this.$http.get(`/api/protected/compragado/getbyid/${compraGadoId}`)
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler a Compra de Gado!' )
        this.controles.falhaNaAbertura = true
      }
        
      
      let compraGadoAux = compraGadoResult.data?.[0]

      if (!compraGadoAux) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler a Compra de Gado!' )
        this.controles.falhaNaAbertura = true
      }

      this.ajustarCamposRegistro(compraGadoAux)
             
      this.registro.info.gta = compraGadoAux.GTA
      this.registro.info.dataAbate = compraGadoAux.DT_LOTE

      this.registro.dados.ID  = compraGadoAux.ID
      this.registro.dados.ID_FORNECEDOR  = compraGadoAux.ID_FORNECEDOR
      this.registro.dados.ID_CONFERENTE  = compraGadoAux.ID_CONFERENTE
      this.registro.dados.DT_LANCAMENTO  = compraGadoAux.DT_LANCAMENTO
      this.registro.dados.DT_ABATE  = compraGadoAux.DT_ABATE
      this.registro.dados.ID_BALANCEIRO  = compraGadoAux.ID_BALANCEIRO
      this.registro.dados.ID_COMPRADOR  =  compraGadoAux.ID_COMPRADOR
      this.registro.dados.DT_CARREGAMENTO  = compraGadoAux.DT_CARREGAMENTO
      this.registro.dados.DT_ALTERACAO  = compraGadoAux.DT_ALTERACAO
      this.registro.dados.VL_LOTE  = compraGadoAux.VL_LOTE
      this.registro.dados.TX_MINUTA  = compraGadoAux.TX_MINUTA
      this.registro.dados.OB_OBSERVACOES  = compraGadoAux.OB_OBSERVACOES
      this.registro.dados.OB_OBSERVACOES_LINHA  = compraGadoAux.OB_OBSERVACOES_LINHA
      this.registro.dados.VL_TOTAL_BATE  = compraGadoAux.VL_TOTAL_BATE
      this.registro.dados.ID_GRUPO_APAGAR  = compraGadoAux.ID_GRUPO_APAGAR

      this.registro.dados.PARCELAS = compraGadoAux.PARCELAS
      this.registro.dados.DIAS_ENTRE_PARCELAS = compraGadoAux.DIAS_ENTRE_PARCELAS
                                                            
      this.registro.dados.NR_BOI4_PECAS     = compraGadoAux.NR_BOI4_PECAS !== null   ? compraGadoAux.NR_BOI4_PECAS : 0
      this.registro.dados.NR_BOI4_PESO      = compraGadoAux.NR_BOI4_PESO !== null    ? compraGadoAux.NR_BOI4_PESO : 0
      this.registro.dados.VL_BOI4_ARROBA    = compraGadoAux.VL_BOI4_ARROBA !== null  ? compraGadoAux.VL_BOI4_ARROBA : 0
      this.registro.dados.NR_BOI4_TOTAL     = compraGadoAux.NR_BOI4_TOTAL !== null   ? compraGadoAux.NR_BOI4_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI3_PECAS     = compraGadoAux.NR_BOI3_PECAS !== null   ? compraGadoAux.NR_BOI3_PECAS : 0
      this.registro.dados.NR_BOI3_PESO      = compraGadoAux.NR_BOI3_PESO !== null    ? compraGadoAux.NR_BOI3_PESO : 0
      this.registro.dados.VL_BOI3_ARROBA    = compraGadoAux.VL_BOI3_ARROBA !== null  ? compraGadoAux.VL_BOI3_ARROBA : 0
      this.registro.dados.NR_BOI3_TOTAL     = compraGadoAux.NR_BOI3_TOTAL !== null   ? compraGadoAux.NR_BOI3_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI2_PECAS     = compraGadoAux.NR_BOI2_PECAS !== null   ? compraGadoAux.NR_BOI2_PECAS : 0
      this.registro.dados.NR_BOI2_PESO      = compraGadoAux.NR_BOI2_PESO !== null    ? compraGadoAux.NR_BOI2_PESO : 0
      this.registro.dados.VL_BOI2_ARROBA    = compraGadoAux.VL_BOI2_ARROBA !== null  ? compraGadoAux.VL_BOI2_ARROBA : 0
      this.registro.dados.NR_BOI2_TOTAL     = compraGadoAux.NR_BOI2_TOTAL !== null   ? compraGadoAux.NR_BOI2_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI1_PECAS     = compraGadoAux.NR_BOI1_PECAS !== null   ? compraGadoAux.NR_BOI1_PECAS : 0
      this.registro.dados.NR_BOI1_PESO      = compraGadoAux.NR_BOI1_PESO !== null    ? compraGadoAux.NR_BOI1_PESO : 0
      this.registro.dados.VL_BOI1_ARROBA    = compraGadoAux.VL_BOI1_ARROBA !== null  ? compraGadoAux.VL_BOI1_ARROBA : 0
      this.registro.dados.NR_BOI1_TOTAL     = compraGadoAux.NR_BOI1_TOTAL !== null   ? compraGadoAux.NR_BOI1_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI0_PECAS     = compraGadoAux.NR_BOI0_PECAS !== null   ? compraGadoAux.NR_BOI0_PECAS : 0
      this.registro.dados.NR_BOI0_PESO      = compraGadoAux.NR_BOI0_PESO !== null    ? compraGadoAux.NR_BOI0_PESO : 0
      this.registro.dados.VL_BOI0_ARROBA    = compraGadoAux.VL_BOI0_ARROBA !== null  ? compraGadoAux.VL_BOI0_ARROBA : 0
      this.registro.dados.NR_BOI0_TOTAL     = compraGadoAux.NR_BOI0_TOTAL !== null   ? compraGadoAux.NR_BOI0_TOTAL : 0
                                                                                      
      this.registro.dados.NR_BOI4_PECAS      = compraGadoAux.NR_BOI4_PECAS !== null    ? compraGadoAux.NR_BOI4_PECAS : 0
      this.registro.dados.NR_BOI4_PESO       = compraGadoAux.NR_BOI4_PESO !== null     ? compraGadoAux.NR_BOI4_PESO : 0
      this.registro.dados.VL_BOI4_ARROBA     = compraGadoAux.VL_BOI4_ARROBA !== null   ? compraGadoAux.VL_BOI4_ARROBA : 0
      this.registro.dados.NR_BOI4_TOTAL      = compraGadoAux.NR_BOI4_TOTAL             ? compraGadoAux.NR_BOI4_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI3_PESO       = compraGadoAux.NR_BOI3_PESO !== null     ? compraGadoAux.NR_BOI3_PESO : 0
      this.registro.dados.NR_BOI3_PECAS      = compraGadoAux.NR_BOI3_PECAS !== null    ? compraGadoAux.NR_BOI3_PECAS : 0
      this.registro.dados.VL_BOI3_ARROBA     = compraGadoAux.VL_BOI3_ARROBA !== null   ? compraGadoAux.VL_BOI3_ARROBA : 0
      this.registro.dados.NR_BOI3_TOTAL      = compraGadoAux.NR_BOI3_TOTAL             ? compraGadoAux.NR_BOI3_TOTAL : 0
                                                                      
      this.registro.dados.NR_BOI2_PESO       = compraGadoAux.NR_BOI2_PESO !== null     ? compraGadoAux.NR_BOI2_PESO : 0
      this.registro.dados.NR_BOI2_PECAS      = compraGadoAux.NR_BOI2_PECAS !== null    ? compraGadoAux.NR_BOI2_PECAS : 0
      this.registro.dados.VL_BOI2_ARROBA     = compraGadoAux.VL_BOI2_ARROBA !== null   ? compraGadoAux.VL_BOI2_ARROBA : 0
      this.registro.dados.NR_BOI2_TOTAL      = compraGadoAux.NR_BOI2_TOTAL             ? compraGadoAux.NR_BOI2_TOTAL : 0
                                                                                      
      this.registro.dados.NR_BOI1_PESO       = compraGadoAux.NR_BOI1_PESO !== null     ? compraGadoAux.NR_BOI1_PESO : 0
      this.registro.dados.NR_BOI1_PECAS      = compraGadoAux.NR_BOI1_PECAS !== null    ? compraGadoAux.NR_BOI1_PECAS : 0
      this.registro.dados.VL_BOI1_ARROBA     = compraGadoAux.VL_BOI1_ARROBA !== null   ? compraGadoAux.VL_BOI1_ARROBA : 0
      this.registro.dados.NR_BOI1_TOTAL      = compraGadoAux.NR_BOI1_TOTAL !== null    ? compraGadoAux.NR_BOI1_TOTAL : 0
                                                                                      
      this.registro.dados.NR_BOI0_PECAS      = compraGadoAux.NR_BOI0_PECAS !== null    ? compraGadoAux.NR_BOI0_PECAS : 0
      this.registro.dados.NR_BOI0_PESO       = compraGadoAux.NR_BOI0_PESO !== null     ? compraGadoAux.NR_BOI0_PESO : 0
      this.registro.dados.VL_BOI0_ARROBA     = compraGadoAux.VL_BOI0_ARROBA !== null   ? compraGadoAux.VL_BOI0_ARROBA : 0
      this.registro.dados.NR_BOI0_TOTAL      = compraGadoAux.NR_BOI0_TOTAL !== null    ? compraGadoAux.NR_BOI0_TOTAL : 0
                                                                    
      this.registro.dados.NR_TOURO4_PECAS    = compraGadoAux.NR_TOURO4_PECAS !== null  ? compraGadoAux.NR_TOURO4_PECAS : 0
      this.registro.dados.NR_TOURO4_PESO     = compraGadoAux.NR_TOURO4_PESO !== null   ? compraGadoAux.NR_TOURO4_PESO : 0
      this.registro.dados.VL_TOURO4_ARROBA   = compraGadoAux.VL_TOURO4_ARROBA !== null ? compraGadoAux.VL_TOURO4_ARROBA : 0
      this.registro.dados.NR_TOURO4_TOTAL    = compraGadoAux.NR_TOURO4_TOTAL !== null  ? compraGadoAux.NR_TOURO4_TOTAL : 0
                                                                    
      this.registro.dados.NR_TOURO3_PECAS    = compraGadoAux.NR_TOURO3_PECAS !== null  ? compraGadoAux.NR_TOURO3_PECAS : 0
      this.registro.dados.NR_TOURO3_PESO     = compraGadoAux.NR_TOURO3_PESO !== null   ? compraGadoAux.NR_TOURO3_PESO : 0
      this.registro.dados.VL_TOURO3_ARROBA   = compraGadoAux.VL_TOURO3_ARROBA !== null ? compraGadoAux.VL_TOURO3_ARROBA : 0
      this.registro.dados.NR_TOURO3_TOTAL    = compraGadoAux.NR_TOURO3_TOTAL !== null  ? compraGadoAux.NR_TOURO3_TOTAL : 0
                                                                    
      this.registro.dados.NR_TOURO2_PECAS    = compraGadoAux.NR_TOURO2_PECAS !== null  ? compraGadoAux.NR_TOURO2_PECAS : 0
      this.registro.dados.NR_TOURO2_PESO     = compraGadoAux.NR_TOURO2_PESO !== null   ? compraGadoAux.NR_TOURO2_PESO : 0
      this.registro.dados.VL_TOURO2_ARROBA   = compraGadoAux.VL_TOURO2_ARROBA !== null ? compraGadoAux.VL_TOURO2_ARROBA : 0
      this.registro.dados.NR_TOURO2_TOTAL    = compraGadoAux.NR_TOURO2_TOTAL !== null  ? compraGadoAux.NR_TOURO2_TOTAL : 0
                                                                    
      this.registro.dados.NR_TOURO1_PECAS    = compraGadoAux.NR_TOURO1_PECAS !== null  ? compraGadoAux.NR_TOURO1_PECAS : 0
      this.registro.dados.NR_TOURO1_PESO     = compraGadoAux.NR_TOURO1_PESO !== null   ? compraGadoAux.NR_TOURO1_PESO : 0
      this.registro.dados.VL_TOURO1_ARROBA   = compraGadoAux.VL_TOURO1_ARROBA !== null ? compraGadoAux.VL_TOURO1_ARROBA : 0
      this.registro.dados.NR_TOURO1_TOTAL    = compraGadoAux.NR_TOURO1_TOTAL !== null  ? compraGadoAux.NR_TOURO1_TOTAL : 0
                                                                    
      this.registro.dados.NR_TOURO0_PECAS    = compraGadoAux.NR_TOURO0_PECAS !== null  ? compraGadoAux.NR_TOURO0_PECAS : 0
      this.registro.dados.NR_TOURO0_PESO     = compraGadoAux.NR_TOURO0_PESO !== null   ? compraGadoAux.NR_TOURO0_PESO : 0
      this.registro.dados.VL_TOURO0_ARROBA   = compraGadoAux.VL_TOURO0_ARROBA !== null ? compraGadoAux.VL_TOURO0_ARROBA : 0
      this.registro.dados.NR_TOURO0_TOTAL    = compraGadoAux.NR_TOURO0_TOTAL !== null  ? compraGadoAux.NR_TOURO0_TOTAL : 0
                                                                    
      this.registro.dados.NR_NOVILHA4_PECAS  = compraGadoAux.NR_NOVILHA4_PECAS !== null? compraGadoAux.NR_NOVILHA4_PECAS : 0
      this.registro.dados.NR_NOVILHA4_PESO   = compraGadoAux.NR_NOVILHA4_PESO !== null ? compraGadoAux.NR_NOVILHA4_PESO : 0
      this.registro.dados.VL_NOVILHA4_ARROBA = compraGadoAux.VL_NOVILHA4_ARROBA !== null ? compraGadoAux.VL_NOVILHA4_ARROBA : 0
      this.registro.dados.NR_NOVILHA4_TOTAL  = compraGadoAux.NR_NOVILHA4_TOTAL !== null? compraGadoAux.NR_NOVILHA4_TOTAL : 0
                                                                    
      this.registro.dados.NR_NOVILHA3_PECAS  = compraGadoAux.NR_NOVILHA3_PECAS !== null? compraGadoAux.NR_NOVILHA3_PECAS : 0
      this.registro.dados.NR_NOVILHA3_PESO   = compraGadoAux.NR_NOVILHA3_PESO !== null ? compraGadoAux.NR_NOVILHA3_PESO : 0
      this.registro.dados.VL_NOVILHA3_ARROBA = compraGadoAux.VL_NOVILHA3_ARROBA !== null? compraGadoAux.VL_NOVILHA3_ARROBA : 0
      this.registro.dados.NR_NOVILHA3_TOTAL  = compraGadoAux.NR_NOVILHA3_TOTAL !== null? compraGadoAux.NR_NOVILHA3_TOTAL : 0
                                                                    
      this.registro.dados.NR_NOVILHA2_PECAS  = compraGadoAux.NR_NOVILHA2_PECAS !== null? compraGadoAux.NR_NOVILHA2_PECAS : 0
      this.registro.dados.NR_NOVILHA2_PESO   = compraGadoAux.NR_NOVILHA2_PESO !== null ? compraGadoAux.NR_NOVILHA2_PESO : 0
      this.registro.dados.VL_NOVILHA2_ARROBA = compraGadoAux.VL_NOVILHA2_ARROBA !== null? compraGadoAux.VL_NOVILHA2_ARROBA : 0
      this.registro.dados.NR_NOVILHA2_TOTAL  = compraGadoAux.NR_NOVILHA2_TOTAL !== null? compraGadoAux.NR_NOVILHA2_TOTAL : 0
                                                                    
      this.registro.dados.NR_NOVILHA1_PECAS  = compraGadoAux.NR_NOVILHA1_PECAS !== null? compraGadoAux.NR_NOVILHA1_PECAS : 0
      this.registro.dados.NR_NOVILHA1_PESO   = compraGadoAux.NR_NOVILHA1_PESO !== null ? compraGadoAux.NR_NOVILHA1_PESO : 0
      this.registro.dados.VL_NOVILHA1_ARROBA = compraGadoAux.VL_NOVILHA1_ARROBA !== null? compraGadoAux.VL_NOVILHA1_ARROBA : 0
      this.registro.dados.NR_NOVILHA1_TOTAL  = compraGadoAux.NR_NOVILHA1_TOTAL !== null? compraGadoAux.NR_NOVILHA1_TOTAL : 0
                                                                    
      this.registro.dados.NR_BOI_CAPAO0_PECAS  = compraGadoAux.NR_BOI_CAPAO0_PECAS !== null? compraGadoAux.NR_BOI_CAPAO0_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO0_PESO   = compraGadoAux.NR_BOI_CAPAO0_PESO !== null ? compraGadoAux.NR_BOI_CAPAO0_PESO : 0
      this.registro.dados.VL_BOI_CAPAO0_ARROBA = compraGadoAux.VL_BOI_CAPAO0_ARROBA !== null? compraGadoAux.VL_BOI_CAPAO0_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO0_TOTAL  = compraGadoAux.NR_BOI_CAPAO0_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO0_TOTAL : 0

      this.registro.dados.NR_BOI_CAPAO4_PECAS  = compraGadoAux.NR_BOI_CAPAO4_PECAS !== null? compraGadoAux.NR_BOI_CAPAO4_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO4_PESO   = compraGadoAux.NR_BOI_CAPAO4_PESO !== null ? compraGadoAux.NR_BOI_CAPAO4_PESO : 0
      this.registro.dados.VL_BOI_CAPAO4_ARROBA = compraGadoAux.VL_BOI_CAPAO4_ARROBA !== null ? compraGadoAux.VL_BOI_CAPAO4_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO4_TOTAL  = compraGadoAux.NR_BOI_CAPAO4_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO4_TOTAL : 0
                                                                    
      this.registro.dados.NR_BOI_CAPAO3_PECAS  = compraGadoAux.NR_BOI_CAPAO3_PECAS !== null? compraGadoAux.NR_BOI_CAPAO3_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO3_PESO   = compraGadoAux.NR_BOI_CAPAO3_PESO !== null ? compraGadoAux.NR_BOI_CAPAO3_PESO : 0
      this.registro.dados.VL_BOI_CAPAO3_ARROBA = compraGadoAux.VL_BOI_CAPAO3_ARROBA !== null? compraGadoAux.VL_BOI_CAPAO3_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO3_TOTAL  = compraGadoAux.NR_BOI_CAPAO3_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO3_TOTAL : 0
                                                                    
      this.registro.dados.NR_BOI_CAPAO2_PECAS  = compraGadoAux.NR_BOI_CAPAO2_PECAS !== null? compraGadoAux.NR_BOI_CAPAO2_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO2_PESO   = compraGadoAux.NR_BOI_CAPAO2_PESO !== null ? compraGadoAux.NR_BOI_CAPAO2_PESO : 0
      this.registro.dados.VL_BOI_CAPAO2_ARROBA = compraGadoAux.VL_BOI_CAPAO2_ARROBA !== null? compraGadoAux.VL_BOI_CAPAO2_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO2_TOTAL  = compraGadoAux.NR_BOI_CAPAO2_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO2_TOTAL : 0
                                                                    
      this.registro.dados.NR_BOI_CAPAO1_PECAS  = compraGadoAux.NR_BOI_CAPAO1_PECAS !== null? compraGadoAux.NR_BOI_CAPAO1_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO1_PESO   = compraGadoAux.NR_BOI_CAPAO1_PESO !== null ? compraGadoAux.NR_BOI_CAPAO1_PESO : 0
      this.registro.dados.VL_BOI_CAPAO1_ARROBA = compraGadoAux.VL_BOI_CAPAO1_ARROBA !== null? compraGadoAux.VL_BOI_CAPAO1_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO1_TOTAL  = compraGadoAux.NR_BOI_CAPAO1_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO1_TOTAL : 0
                                                                    
      this.registro.dados.NR_BOI_CAPAO0_PECAS  = compraGadoAux.NR_BOI_CAPAO0_PECAS !== null? compraGadoAux.NR_BOI_CAPAO0_PECAS : 0
      this.registro.dados.NR_BOI_CAPAO0_PESO   = compraGadoAux.NR_BOI_CAPAO0_PESO !== null ? compraGadoAux.NR_BOI_CAPAO0_PESO : 0
      this.registro.dados.VL_BOI_CAPAO0_ARROBA = compraGadoAux.VL_BOI_CAPAO0_ARROBA !== null? compraGadoAux.VL_BOI_CAPAO0_ARROBA : 0
      this.registro.dados.NR_BOI_CAPAO0_TOTAL  = compraGadoAux.NR_BOI_CAPAO0_TOTAL !== null? compraGadoAux.NR_BOI_CAPAO0_TOTAL : 0

      this.registro.dados.NR_BUFALO_MACHO4_PECAS  = compraGadoAux.NR_BUFALO_MACHO4_PECAS !== null  ? compraGadoAux.NR_BUFALO_MACHO4_PECAS : 0
      this.registro.dados.NR_BUFALO_MACHO4_PESO   = compraGadoAux.NR_BUFALO_MACHO4_PESO !== null   ? compraGadoAux.NR_BUFALO_MACHO4_PESO : 0
      this.registro.dados.VL_BUFALO_MACHO4_ARROBA = compraGadoAux.VL_BUFALO_MACHO4_ARROBA !== null ? compraGadoAux.VL_BUFALO_MACHO4_ARROBA : 0
      this.registro.dados.NR_BUFALO_MACHO4_TOTAL  = compraGadoAux.NR_BUFALO_MACHO4_TOTAL           ? compraGadoAux.NR_BUFALO_MACHO4_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_MACHO3_PECAS  = compraGadoAux.NR_BUFALO_MACHO3_PECAS !== null  ? compraGadoAux.NR_BUFALO_MACHO3_PECAS : 0
      this.registro.dados.NR_BUFALO_MACHO3_PESO   = compraGadoAux.NR_BUFALO_MACHO3_PESO !== null   ? compraGadoAux.NR_BUFALO_MACHO3_PESO : 0
      this.registro.dados.VL_BUFALO_MACHO3_ARROBA = compraGadoAux.VL_BUFALO_MACHO3_ARROBA !== null ? compraGadoAux.VL_BUFALO_MACHO3_ARROBA : 0
      this.registro.dados.NR_BUFALO_MACHO3_TOTAL  = compraGadoAux.NR_BUFALO_MACHO3_TOTAL           ? compraGadoAux.NR_BUFALO_MACHO3_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_MACHO2_PECAS  = compraGadoAux.NR_BUFALO_MACHO2_PECAS !== null  ? compraGadoAux.NR_BUFALO_MACHO2_PECAS : 0
      this.registro.dados.NR_BUFALO_MACHO2_PESO   = compraGadoAux.NR_BUFALO_MACHO2_PESO !== null   ? compraGadoAux.NR_BUFALO_MACHO2_PESO : 0
      this.registro.dados.VL_BUFALO_MACHO2_ARROBA = compraGadoAux.VL_BUFALO_MACHO2_ARROBA !== null ? compraGadoAux.VL_BUFALO_MACHO2_ARROBA : 0
      this.registro.dados.NR_BUFALO_MACHO2_TOTAL  = compraGadoAux.NR_BUFALO_MACHO2_TOTAL           ? compraGadoAux.NR_BUFALO_MACHO2_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_MACHO1_PECAS  = compraGadoAux.NR_BUFALO_MACHO1_PECAS !== null  ? compraGadoAux.NR_BUFALO_MACHO1_PECAS : 0
      this.registro.dados.NR_BUFALO_MACHO1_PESO   = compraGadoAux.NR_BUFALO_MACHO1_PESO !== null   ? compraGadoAux.NR_BUFALO_MACHO1_PESO : 0
      this.registro.dados.VL_BUFALO_MACHO1_ARROBA = compraGadoAux.VL_BUFALO_MACHO1_ARROBA !== null ? compraGadoAux.VL_BUFALO_MACHO1_ARROBA : 0
      this.registro.dados.NR_BUFALO_MACHO1_TOTAL  = compraGadoAux.NR_BUFALO_MACHO1_TOTAL           ? compraGadoAux.NR_BUFALO_MACHO1_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_MACHO0_PECAS  = compraGadoAux.NR_BUFALO_MACHO0_PECAS !== null  ? compraGadoAux.NR_BUFALO_MACHO0_PECAS : 0
      this.registro.dados.NR_BUFALO_MACHO0_PESO   = compraGadoAux.NR_BUFALO_MACHO0_PESO !== null   ? compraGadoAux.NR_BUFALO_MACHO0_PESO : 0
      this.registro.dados.VL_BUFALO_MACHO0_ARROBA = compraGadoAux.VL_BUFALO_MACHO0_ARROBA !== null ? compraGadoAux.VL_BUFALO_MACHO0_ARROBA : 0
      this.registro.dados.NR_BUFALO_MACHO0_TOTAL  = compraGadoAux.NR_BUFALO_MACHO0_TOTAL           ? compraGadoAux.NR_BUFALO_MACHO0_TOTAL : 0

      this.registro.dados.NR_BUFALO_FEMEA4_PECAS  = compraGadoAux.NR_BUFALO_FEMEA4_PECAS !== null  ? compraGadoAux.NR_BUFALO_FEMEA4_PECAS : 0
      this.registro.dados.NR_BUFALO_FEMEA4_PESO   = compraGadoAux.NR_BUFALO_FEMEA4_PESO !== null   ? compraGadoAux.NR_BUFALO_FEMEA4_PESO : 0
      this.registro.dados.VL_BUFALO_FEMEA4_ARROBA = compraGadoAux.VL_BUFALO_FEMEA4_ARROBA !== null ? compraGadoAux.VL_BUFALO_FEMEA4_ARROBA : 0
      this.registro.dados.NR_BUFALO_FEMEA4_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA4_TOTAL           ? compraGadoAux.NR_BUFALO_FEMEA4_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_FEMEA3_PECAS  = compraGadoAux.NR_BUFALO_FEMEA3_PECAS !== null  ? compraGadoAux.NR_BUFALO_FEMEA3_PECAS : 0
      this.registro.dados.NR_BUFALO_FEMEA3_PESO   = compraGadoAux.NR_BUFALO_FEMEA3_PESO !== null   ? compraGadoAux.NR_BUFALO_FEMEA3_PESO : 0
      this.registro.dados.VL_BUFALO_FEMEA3_ARROBA = compraGadoAux.VL_BUFALO_FEMEA3_ARROBA !== null ? compraGadoAux.VL_BUFALO_FEMEA3_ARROBA : 0
      this.registro.dados.NR_BUFALO_FEMEA3_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA3_TOTAL           ? compraGadoAux.NR_BUFALO_FEMEA3_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_FEMEA2_PECAS  = compraGadoAux.NR_BUFALO_FEMEA2_PECAS !== null  ? compraGadoAux.NR_BUFALO_FEMEA2_PECAS : 0
      this.registro.dados.NR_BUFALO_FEMEA2_PESO   = compraGadoAux.NR_BUFALO_FEMEA2_PESO !== null   ? compraGadoAux.NR_BUFALO_FEMEA2_PESO : 0
      this.registro.dados.VL_BUFALO_FEMEA2_ARROBA = compraGadoAux.VL_BUFALO_FEMEA2_ARROBA !== null ? compraGadoAux.VL_BUFALO_FEMEA2_ARROBA : 0
      this.registro.dados.NR_BUFALO_FEMEA2_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA2_TOTAL           ? compraGadoAux.NR_BUFALO_FEMEA2_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_FEMEA1_PECAS  = compraGadoAux.NR_BUFALO_FEMEA1_PECAS !== null  ? compraGadoAux.NR_BUFALO_FEMEA1_PECAS : 0
      this.registro.dados.NR_BUFALO_FEMEA1_PESO   = compraGadoAux.NR_BUFALO_FEMEA1_PESO !== null   ? compraGadoAux.NR_BUFALO_FEMEA1_PESO : 0
      this.registro.dados.VL_BUFALO_FEMEA1_ARROBA = compraGadoAux.VL_BUFALO_FEMEA1_ARROBA !== null ? compraGadoAux.VL_BUFALO_FEMEA1_ARROBA : 0
      this.registro.dados.NR_BUFALO_FEMEA1_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA1_TOTAL           ? compraGadoAux.NR_BUFALO_FEMEA1_TOTAL : 0
                                                                    
      this.registro.dados.NR_BUFALO_FEMEA0_PECAS  = compraGadoAux.NR_BUFALO_FEMEA0_PECAS !== null  ? compraGadoAux.NR_BUFALO_FEMEA0_PECAS : 0
      this.registro.dados.NR_BUFALO_FEMEA0_PESO   = compraGadoAux.NR_BUFALO_FEMEA0_PESO !== null   ? compraGadoAux.NR_BUFALO_FEMEA0_PESO : 0
      this.registro.dados.VL_BUFALO_FEMEA0_ARROBA = compraGadoAux.VL_BUFALO_FEMEA0_ARROBA !== null ? compraGadoAux.VL_BUFALO_FEMEA0_ARROBA : 0
      this.registro.dados.NR_BUFALO_FEMEA0_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA0_TOTAL           ? compraGadoAux.NR_BUFALO_FEMEA0_TOTAL : 0
                                                            
      this.registro.dados.DT_VENCIMENTO  = compraGadoAux.DT_VENCIMENTO
      this.registro.dados.OP_STATUS  = compraGadoAux.OP_STATUS
      this.registro.dados.VL_FRETE  = compraGadoAux.VL_FRETE
      this.registro.dados.TX_PLACA  = compraGadoAux.TX_PLACA
      this.registro.dados.QUANT_BANDAS  = compraGadoAux.QUANT_BANDAS
      this.registro.dados.PECAS_BANDA  = compraGadoAux.PECAS_BANDA
      this.registro.dados.DT_LANCA_BANDA  = compraGadoAux.DT_LANCA_BANDA
      this.registro.dados.USUARIO_LANCA_BANDA  = compraGadoAux.USUARIO_LANCA_BANDA
      this.registro.dados.OP_BANDAS  = compraGadoAux.OP_BANDAS
      this.registro.dados.PERCENTUAL_FUNRURAL  = compraGadoAux.PERCENTUAL_FUNRURAL ? compraGadoAux.PERCENTUAL_FUNRURAL : 0.00
      this.registro.dados.VL_FUNRURAL  = compraGadoAux.VL_FUNRURAL ? compraGadoAux.VL_FUNRURAL : 0.00
      this.registro.dados.VL_TOTAL_BRUTO  = compraGadoAux.VL_TOTAL_BRUTO ? compraGadoAux.VL_TOTAL_BRUTO : 0.00
      this.registro.dados.CENTRO_ESTOQUE_ID  = compraGadoAux.CENTRO_ESTOQUE_ID
      this.registro.dados.TRANSPORTADORA_ID  = compraGadoAux.TRANSPORTADORA_ID
      this.registro.dados.OP_TIPO_DOCUMENTO  = compraGadoAux.OP_TIPO_DOCUMENTO
      this.registro.dados.DOCUMENTO  = compraGadoAux.DOCUMENTO
      this.registro.dados.GTA  = compraGadoAux.GTA
      this.registro.dados.DT_CANCELAMENTO  = compraGadoAux.DT_CANCELAMENTO
      this.registro.dados.USUARIO_CANCELAMENTO  = compraGadoAux.USUARIO_CANCELAMENTO
      this.registro.dados.MOTIVO_CANCELAMENTO  = compraGadoAux.MOTIVO_CANCELAMENTO
      this.registro.dados.MARCHANT_ID  = compraGadoAux.MARCHANT_ID
      this.registro.dados.FAZENDA_ID  = compraGadoAux.FAZENDA_ID
      this.registro.dados.BALANCEIRO_ID  = compraGadoAux.BALANCEIRO_ID
      this.registro.dados.MOTORISTA_ID  = compraGadoAux.MOTORISTA_ID
      this.registro.dados.NR_BOI_PECAS_TOTAL  = compraGadoAux.NR_BOI_PECAS_TOTAL
      this.registro.dados.NR_BOI_PECAS_TOTAL  = compraGadoAux.NR_BOI_PECAS_TOTAL
      this.registro.dados.NR_TOURO_PECAS_TOTAL  = compraGadoAux.NR_TOURO_PECAS_TOTAL
      this.registro.dados.NR_NOVILHA_PECAS_TOTAL  = compraGadoAux.NR_NOVILHA_PECAS_TOTAL
      this.registro.dados.NR_BOI_CAPAO_PECAS_TOTAL  = compraGadoAux.NR_BOI_CAPAO_PECAS_TOTAL
      this.registro.dados.NR_BUFALO_MACHO_PECAS_TOTAL  = compraGadoAux.NR_BUFALO_MACHO_PECAS_TOTAL ? compraGadoAux.NR_BUFALO_MACHO_PECAS_TOTAL : 0
      this.registro.dados.NR_BUFALO_FEMEA_PECAS_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA_PECAS_TOTAL ? compraGadoAux.NR_BUFALO_FEMEA_PECAS_TOTAL : 0
      this.registro.dados.OP_GERA_APAGAR  = compraGadoAux.OP_GERA_APAGAR
      this.registro.dados.NR_BOI_PESO_TOTAL  = compraGadoAux.NR_BOI_PESO_TOTAL
      this.registro.dados.NR_NOVILHA_PESO_TOTAL  = compraGadoAux.NR_NOVILHA_PESO_TOTAL
      this.registro.dados.NR_BOI_PESO_TOTAL  = compraGadoAux.NR_BOI_PESO_TOTAL
      this.registro.dados.NR_TOURO_PESO_TOTAL  = compraGadoAux.NR_TOURO_PESO_TOTAL
      this.registro.dados.NR_BOI_CAPAO_PESO_TOTAL  = compraGadoAux.NR_BOI_CAPAO_PESO_TOTAL
      this.registro.dados.NR_BUFALO_MACHO_PESO_TOTAL  = compraGadoAux.NR_BUFALO_MACHO_PESO_TOTAL ? compraGadoAux.NR_BUFALO_MACHO_PESO_TOTAL : 0.00
      this.registro.dados.NR_BUFALO_FEMEA_PESO_TOTAL  = compraGadoAux.NR_BUFALO_FEMEA_PESO_TOTAL ? compraGadoAux.NR_BUFALO_FEMEA_PESO_TOTAL : 0.00
      this.registro.dados.ABATE_ID  = compraGadoAux.ABATE_ID
      this.registro.dados.OP_ABATIDO  = compraGadoAux.OP_ABATIDO

      let infoFornecedorResult = null
      try {
        infoFornecedorResult = await this.$http.get(`/api/protected/cliente/pesquisaridmin?idPesquisa=${this.registro.dados.ID_FORNECEDOR}`)
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler a Compra de Gado!' )
        this.controles.falhaNaAbertura = true
      }
          
      let infoFornecedor = infoFornecedorResult.data?.[0]
      this.registro.info.fornecedor = infoFornecedor?.CODIGONOME

      let parcelamentoResult = null
      try {
        parcelamentoResult = await this.$http.get(`/api/protected/compragado/parcelamento/getByCompraGado/${compraGadoId}`)
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel ler o Parcelamento!' )
        this.controles.falhaNaAbertura = true
      }
      
      this.parcelamento.items = parcelamentoResult.data?? null
      this.parcelamento.vezes = this.parcelamento.items?.length

    },
    ajustarCamposRegistro(registro) {
      this.registro.info.dataAbate = Tools.formatarDataParaInput(this.registro.dados.DT_LOTE)
      registro.DT_ABATE  = Tools.formatarDataParaInput(registro.DT_ABATE)
      registro.DT_VENCIMENTO  = Tools.formatarDataParaInput(registro.DT_VENCIMENTO)
      registro.OP_STATUS  = registro.OP_STATUS?.trim()
      registro.ID_COMPRADOR  =  parseInt(registro.ID_COMPRADOR)
      registro.ID_CONFERENTE  =  parseInt(registro.ID_CONFERENTE)
      registro.ID_BALANCEIRO  =  parseInt(registro.ID_BALANCEIRO)
      registro.ID_FORNECEDOR  =  parseInt(registro.ID_FORNECEDOR)
    },
    zerarAnimais () {
      this.registro.dados.ID = null
      // this.registro.dados.ABATE_ID = 0
      this.registro.dados.OP_ABATIDO = 0
      this.registro.dados.DT_CANCELAMENTO = 0
      this.registro.dados.USUARIO_CANCELAMENTO = 0
      this.registro.dados.MOTIVO_CANCELAMENTO = 0
      this.registro.dados.MARCHANT_ID = 0
      this.registro.dados.FAZENDA_ID = 0
      this.registro.dados.BALANCEIRO_ID = 0
      this.registro.dados.MOTORISTA_ID = 0
      this.registro.dados.OP_GERA_APAGAR = 0
      this.registro.dados.ID_FORNECEDOR = null
      this.registro.dados.ID_CONFERENTE = null
      this.registro.dados.DT_LANCAMENTO = null
      this.registro.dados.DT_ABATE = Tools.getDataAtual()
      this.registro.dados.ID_BALANCEIRO = null
      this.registro.dados.ID_COMPRADOR = null
      this.registro.dados.DT_CARREGAMENTO = null
      this.registro.dados.DT_ALTERACAO = null
      this.registro.dados.VL_LOTE = null
      this.registro.dados.TX_MINUTA = null
      this.registro.dados.OB_OBSERVACOES = null
      this.registro.dados.OB_OBSERVACOES_LINHA = null
      this.registro.dados.VL_TOTAL_BATE = 0
      this.registro.dados.ID_GRUPO_APAGAR = null
      this.registro.dados.DT_VENCIMENTO = Tools.getDataAtual()
      this.registro.dados.OP_STATUS = 2
      this.registro.dados.VL_FRETE = 0
      this.registro.dados.TX_PLACA = 0
      this.registro.dados.QUANT_BANDAS = 0
      this.registro.dados.PECAS_BANDA = 0
      this.registro.dados.DT_LANCA_BANDA = 0
      this.registro.dados.USUARIO_LANCA_BANDA = 0
      this.registro.dados.OP_BANDAS = 0
      this.registro.dados.PERCENTUAL_FUNRURAL = 0
      this.registro.dados.VL_FUNRURAL = 0
      this.registro.dados.VL_TOTAL_BRUTO = 0
      this.registro.dados.CENTRO_ESTOQUE_ID = 0
      this.registro.dados.TRANSPORTADORA_ID = 0
      this.registro.dados.OP_TIPO_DOCUMENTO = 0
      this.registro.dados.DOCUMENTO = 0
      this.registro.dados.GTA = 0
      
      this.registro.dados.PARCELAS = 1
      this.registro.dados.DIAS_ENTRE_PARCELAS = 0


      
      /* BOI ***************************************************/
      this.registro.dados.NR_BOI4_PECAS = 0.00
      this.registro.dados.NR_BOI4_PESO = 0.00
      this.registro.dados.VL_BOI4_ARROBA = 0.00
      this.registro.dados.NR_BOI4_TOTAL = 0.00


      this.registro.dados.NR_BOI3_PECAS = 0.00
      this.registro.dados.NR_BOI3_PESO = 0.00
      this.registro.dados.VL_BOI3_ARROBA = 0.00
      this.registro.dados.NR_BOI3_TOTAL = 0.00


      this.registro.dados.NR_BOI2_PECAS = 0.00
      this.registro.dados.NR_BOI2_PESO = 0.00
      this.registro.dados.VL_BOI2_ARROBA = 0.00
      this.registro.dados.NR_BOI2_TOTAL = 0.00


      this.registro.dados.NR_BOI1_PESO = 0.00
      this.registro.dados.NR_BOI1_PECAS = 0.00
      this.registro.dados.VL_BOI1_ARROBA = 0.00
      this.registro.dados.NR_BOI1_TOTAL = 0.00

      this.registro.dados.NR_BOI0_PECAS = 0.00
      this.registro.dados.NR_BOI0_PESO = 0.00
      this.registro.dados.VL_BOI0_ARROBA = 0.00
      this.registro.dados.NR_BOI0_TOTAL = 0.00


      /* BOI ***************************************************/
      this.registro.dados.NR_BOI4_PECAS = 0.00
      this.registro.dados.NR_BOI4_PESO = 0.00
      this.registro.dados.VL_BOI4_ARROBA = 0.00
      this.registro.dados.NR_BOI4_TOTAL = 0.00

      this.registro.dados.NR_BOI3_PECAS = 0.00
      this.registro.dados.NR_BOI3_PESO = 0.00
      this.registro.dados.VL_BOI3_ARROBA = 0.00
      this.registro.dados.NR_BOI3_TOTAL = 0.00

      this.registro.dados.NR_BOI2_PESO = 0.00
      this.registro.dados.NR_BOI2_PECAS = 0.00
      this.registro.dados.VL_BOI2_ARROBA = 0.00
      this.registro.dados.NR_BOI2_TOTAL = 0.00

      this.registro.dados.NR_BOI1_PECAS = 0.00
      this.registro.dados.NR_BOI1_PESO = 0.00
      this.registro.dados.VL_BOI1_ARROBA = 0.00
      this.registro.dados.NR_BOI1_TOTAL = 0.00

      this.registro.dados.NR_BOI0_PECAS = 0.00
      this.registro.dados.NR_BOI0_PESO = 0.00
      this.registro.dados.VL_BOI0_ARROBA = 0.00
      this.registro.dados.NR_BOI0_TOTAL = 0.00
      
      /* TOURO ***************************************************/
      this.registro.dados.NR_TOURO4_PECAS = 0.00
      this.registro.dados.NR_TOURO4_PESO = 0.00
      this.registro.dados.VL_TOURO4_ARROBA = 0.00
      this.registro.dados.NR_TOURO4_TOTAL = 0.00

      this.registro.dados.NR_TOURO3_PECAS = 0.00
      this.registro.dados.NR_TOURO3_PESO = 0.00
      this.registro.dados.VL_TOURO3_ARROBA = 0.00
      this.registro.dados.NR_TOURO3_TOTAL = 0.00

      this.registro.dados.NR_TOURO2_PECAS = 0.00
      this.registro.dados.NR_TOURO2_PESO = 0.00
      this.registro.dados.VL_TOURO2_ARROBA = 0.00
      this.registro.dados.NR_TOURO2_TOTAL = 0.00

      this.registro.dados.NR_TOURO1_PECAS = 0.00
      this.registro.dados.NR_TOURO1_PESO = 0.00
      this.registro.dados.VL_TOURO1_ARROBA = 0.00
      this.registro.dados.NR_TOURO1_TOTAL = 0.00

      this.registro.dados.NR_TOURO0_PECAS = 0.00
      this.registro.dados.NR_TOURO0_PESO = 0.00
      this.registro.dados.VL_TOURO0_ARROBA = 0.00
      this.registro.dados.NR_TOURO0_TOTAL = 0.00


       /* NOVILHA  ***************************************************/
      this.registro.dados.NR_NOVILHA0_PECAS = 0.00
      this.registro.dados.NR_NOVILHA0_PESO = 0.00
      this.registro.dados.VL_NOVILHA0_ARROBA = 0.00
      this.registro.dados.NR_NOVILHA0_TOTAL = 0.00
      
      this.registro.dados.NR_NOVILHA1_PECAS = 0.00
      this.registro.dados.NR_NOVILHA1_PESO = 0.00
      this.registro.dados.VL_NOVILHA1_ARROBA = 0.00
      this.registro.dados.NR_NOVILHA1_TOTAL = 0.00
      
      this.registro.dados.NR_NOVILHA2_PECAS = 0.00
      this.registro.dados.NR_NOVILHA2_PESO = 0.00
      this.registro.dados.VL_NOVILHA2_ARROBA = 0.00
      this.registro.dados.NR_NOVILHA2_TOTAL = 0.00
      
      this.registro.dados.NR_NOVILHA3_PECAS = 0.00
      this.registro.dados.NR_NOVILHA3_PESO = 0.00
      this.registro.dados.VL_NOVILHA3_ARROBA = 0.00
      this.registro.dados.NR_NOVILHA3_TOTAL = 0.00

      this.registro.dados.NR_NOVILHA4_PECAS = 0.00
      this.registro.dados.NR_NOVILHA4_PESO = 0.00
      this.registro.dados.VL_NOVILHA4_ARROBA = 0.00
      this.registro.dados.NR_NOVILHA4_TOTAL = 0.00

      /* BOI CAPAO  ***************************************************/
      this.registro.dados.NR_BOI_CAPAO0_PECAS = 0.00
      this.registro.dados.NR_BOI_CAPAO0_PESO = 0.00
      this.registro.dados.VL_BOI_CAPAO0_ARROBA = 0.00
      this.registro.dados.NR_BOI_CAPAO0_TOTAL = 0.00
      
      this.registro.dados.NR_BOI_CAPAO1_PECAS = 0.00
      this.registro.dados.NR_BOI_CAPAO1_PESO = 0.00
      this.registro.dados.VL_BOI_CAPAO1_ARROBA = 0.00
      this.registro.dados.NR_BOI_CAPAO1_TOTAL = 0.00
      
      this.registro.dados.NR_BOI_CAPAO2_PECAS = 0.00
      this.registro.dados.NR_BOI_CAPAO2_PESO = 0.00
      this.registro.dados.VL_BOI_CAPAO2_ARROBA = 0.00
      this.registro.dados.NR_BOI_CAPAO2_TOTAL = 0.00
      
      this.registro.dados.NR_BOI_CAPAO3_PECAS = 0.00
      this.registro.dados.NR_BOI_CAPAO3_PESO = 0.00
      this.registro.dados.VL_BOI_CAPAO3_ARROBA = 0.00
      this.registro.dados.NR_BOI_CAPAO3_TOTAL = 0.00

      this.registro.dados.NR_BOI_CAPAO4_PECAS = 0.00
      this.registro.dados.NR_BOI_CAPAO4_PESO = 0.00
      this.registro.dados.VL_BOI_CAPAO4_ARROBA = 0.00
      this.registro.dados.NR_BOI_CAPAO4_TOTAL = 0.00

      /* BUFALO MACHO  ***************************************************/
      this.registro.dados.NR_BUFALO_MACHO0_PECAS = 0.00
      this.registro.dados.NR_BUFALO_MACHO0_PESO = 0.00
      this.registro.dados.VL_BUFALO_MACHO0_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_MACHO0_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_MACHO1_PECAS = 0.00
      this.registro.dados.NR_BUFALO_MACHO1_PESO = 0.00
      this.registro.dados.VL_BUFALO_MACHO1_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_MACHO1_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_MACHO2_PECAS = 0.00
      this.registro.dados.NR_BUFALO_MACHO2_PESO = 0.00
      this.registro.dados.VL_BUFALO_MACHO2_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_MACHO2_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_MACHO3_PECAS = 0.00
      this.registro.dados.NR_BUFALO_MACHO3_PESO = 0.00
      this.registro.dados.VL_BUFALO_MACHO3_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_MACHO3_TOTAL = 0.00

      this.registro.dados.NR_BUFALO_MACHO4_PECAS = 0.00
      this.registro.dados.NR_BUFALO_MACHO4_PESO = 0.00
      this.registro.dados.VL_BUFALO_MACHO4_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_MACHO4_TOTAL = 0.00

      /* BUFALO FEMEA  ***************************************************/
      this.registro.dados.NR_BUFALO_FEMEA0_PECAS = 0.00
      this.registro.dados.NR_BUFALO_FEMEA0_PESO = 0.00
      this.registro.dados.VL_BUFALO_FEMEA0_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_FEMEA0_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_FEMEA1_PECAS = 0.00
      this.registro.dados.NR_BUFALO_FEMEA1_PESO = 0.00
      this.registro.dados.VL_BUFALO_FEMEA1_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_FEMEA1_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_FEMEA2_PECAS = 0.00
      this.registro.dados.NR_BUFALO_FEMEA2_PESO = 0.00
      this.registro.dados.VL_BUFALO_FEMEA2_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_FEMEA2_TOTAL = 0.00
      
      this.registro.dados.NR_BUFALO_FEMEA3_PECAS = 0.00
      this.registro.dados.NR_BUFALO_FEMEA3_PESO = 0.00
      this.registro.dados.VL_BUFALO_FEMEA3_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_FEMEA3_TOTAL = 0.00

      this.registro.dados.NR_BUFALO_FEMEA4_PECAS = 0.00
      this.registro.dados.NR_BUFALO_FEMEA4_PESO = 0.00
      this.registro.dados.VL_BUFALO_FEMEA4_ARROBA = 0.00
      this.registro.dados.NR_BUFALO_FEMEA4_TOTAL = 0.00
           
      this.registro.dados.NR_BOI_PECAS_TOTAL = 0.00
      this.registro.dados.NR_BOI_PECAS_TOTAL = 0.00
      this.registro.dados.NR_TOURO_PECAS_TOTAL = 0.00
      this.registro.dados.NR_NOVILHA_PECAS_TOTAL = 0.00
      this.registro.dados.NR_BOI_CAPAO_PECAS_TOTAL = 0.00
      this.registro.dados.NR_BUFALO_MACHO_PECAS_TOTAL = 0.00
      this.registro.dados.NR_BUFALO_FEMEA_PECAS_TOTAL = 0.00
      
      this.registro.dados.NR_BOI_PESO_TOTAL = 0.00
      this.registro.dados.NR_NOVILHA_PESO_TOTAL = 0.00
      this.registro.dados.NR_BOI_PESO_TOTAL = 0.00
      this.registro.dados.NR_TOURO_PESO_TOTAL = 0.00
      this.registro.dados.NR_BOI_CAPAO_PESO_TOTAL = 0.00
      this.registro.dados.NR_BUFALO_MACHO_PESO_TOTAL = 0.00
      this.registro.dados.NR_BUFALO_FEMEA_PESO_TOTAL = 0.00
    },
    calculaBoi() {
      if ((this.registro.dados.NR_BOI4_PESO) > 0 && (this.registro.dados.NR_BOI4_PECAS) > 0) {
        this.animais.boi.faixa4.media = ((this.registro.dados.NR_BOI4_PESO) / (this.registro.dados.NR_BOI4_PECAS) )
      } else {
        this.animais.boi.faixa4.media = 0
      }
       if ((this.registro.dados.NR_BOI3_PESO) > 0 && (this.registro.dados.NR_BOI3_PECAS) > 0) {
        this.animais.boi.faixa3.media = ((this.registro.dados.NR_BOI3_PESO) / (this.registro.dados.NR_BOI3_PECAS) )
      } else {
        this.animais.boi.faixa3.media = 0
      }
      if ((this.registro.dados.NR_BOI2_PESO) > 0 && (this.registro.dados.NR_BOI2_PECAS) > 0) {
        this.animais.boi.faixa2.media = ((this.registro.dados.NR_BOI2_PESO) / (this.registro.dados.NR_BOI2_PECAS) )
      } else {
        this.animais.boi.faixa2.media = 0
      }
      if ((this.registro.dados.NR_BOI1_PESO) > 0 && (this.registro.dados.NR_BOI1_PECAS) > 0) {
        this.animais.boi.faixa1.media = ((this.registro.dados.NR_BOI1_PESO) / (this.registro.dados.NR_BOI1_PECAS) )
      } else {
        this.animais.boi.faixa1.media = 0
      }
      if ((this.registro.dados.NR_BOI0_PESO) > 0 && (this.registro.dados.NR_BOI0_PECAS) > 0) {
        this.animais.boi.faixa0.media = ((this.registro.dados.NR_BOI0_PESO) / (this.registro.dados.NR_BOI1_PECAS) )
      } else {
        this.animais.boi.faixa0.media = 0
      }
      /* boi TOTAL */
      if ((this.registro.dados.NR_BOI4_PESO) > 0 && (this.registro.dados.VL_BOI4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI4_PESO / 15) * this.registro.dados.VL_BOI4_ARROBA
        this.registro.dados.NR_BOI4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI4_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI3_PESO) > 0 && (this.registro.dados.VL_BOI3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI3_PESO / 15) * this.registro.dados.VL_BOI3_ARROBA
        this.registro.dados.NR_BOI3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI3_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI2_PESO) > 0 && (this.registro.dados.VL_BOI2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI2_PESO / 15) * this.registro.dados.VL_BOI2_ARROBA
        this.registro.dados.NR_BOI2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI2_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI1_PESO) > 0 && (this.registro.dados.VL_BOI1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI1_PESO / 15) * this.registro.dados.VL_BOI1_ARROBA
        this.registro.dados.NR_BOI1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI1_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI0_PESO) > 0 && (this.registro.dados.VL_BOI0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI0_PESO / 15) * this.registro.dados.VL_BOI0_ARROBA
        this.registro.dados.NR_BOI0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaBOI() {
      if ((this.registro.dados.NR_BOI4_PESO) > 0 && (this.registro.dados.NR_BOI4_PECAS) > 0) {
        this.animais.BOI.faixa4.media = ((this.registro.dados.NR_BOI4_PESO) / (this.registro.dados.NR_BOI4_PECAS) )
      } else {
        this.animais.BOI.faixa4.media = 0
      }
       if ((this.registro.dados.NR_BOI3_PESO) > 0 && (this.registro.dados.NR_BOI3_PECAS) > 0) {
        this.animais.BOI.faixa3.media = ((this.registro.dados.NR_BOI3_PESO) / (this.registro.dados.NR_BOI3_PECAS) )
      } else {
        this.animais.BOI.faixa3.media = 0
      }
      if ((this.registro.dados.NR_BOI2_PESO) > 0 && (this.registro.dados.NR_BOI2_PECAS) > 0) {
        this.animais.BOI.faixa2.media = ((this.registro.dados.NR_BOI2_PESO) / (this.registro.dados.NR_BOI2_PECAS) )
      } else {
        this.animais.BOI.faixa2.media = 0
      }
      if ((this.registro.dados.NR_BOI1_PESO) > 0 && (this.registro.dados.NR_BOI1_PECAS) > 0) {
        this.animais.BOI.faixa1.media = ((this.registro.dados.NR_BOI1_PESO) / (this.registro.dados.NR_BOI1_PECAS) )
      } else {
        this.animais.BOI.faixa1.media = 0
      }
      if ((this.registro.dados.NR_BOI0_PESO) > 0 && (this.registro.dados.NR_BOI0_PECAS) > 0) {
        this.animais.BOI.faixa0.media = ((this.registro.dados.NR_BOI0_PESO) / (this.registro.dados.NR_BOI0_PECAS) )
      } else {
        this.animais.BOI.faixa0.media = 0
      }
      /* BOI TOTAL */
      if ((this.registro.dados.NR_BOI4_PESO) > 0 && (this.registro.dados.VL_BOI4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI4_PESO / 15) * this.registro.dados.VL_BOI4_ARROBA
        this.registro.dados.NR_BOI4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI4_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI3_PESO) > 0 && (this.registro.dados.VL_BOI3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI3_PESO / 15) * this.registro.dados.VL_BOI3_ARROBA
        this.registro.dados.NR_BOI3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI3_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI2_PESO) > 0 && (this.registro.dados.VL_BOI2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI2_PESO / 15) * this.registro.dados.VL_BOI2_ARROBA
        this.registro.dados.NR_BOI2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI2_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI1_PESO) > 0 && (this.registro.dados.VL_BOI1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI1_PESO / 15) * this.registro.dados.VL_BOI1_ARROBA
        this.registro.dados.NR_BOI1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI1_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI0_PESO) > 0 && (this.registro.dados.VL_BOI0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI0_PESO / 15) * this.registro.dados.VL_BOI0_ARROBA
        this.registro.dados.NR_BOI0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaTouro() {
      if ((this.registro.dados.NR_TOURO4_PESO) > 0 && (this.registro.dados.NR_TOURO4_PECAS) > 0) {
        this.animais.touro.faixa4.media = ((this.registro.dados.NR_TOURO4_PESO) / (this.registro.dados.NR_TOURO4_PECAS) )
      } else {
        this.animais.touro.faixa4.media = 0
      }
       if ((this.registro.dados.NR_TOURO3_PESO) > 0 && (this.registro.dados.NR_TOURO3_PECAS) > 0) {
        this.animais.touro.faixa3.media = ((this.registro.dados.NR_TOURO3_PESO) / (this.registro.dados.NR_TOURO3_PECAS) )
      } else {
        this.animais.touro.faixa3.media = 0
      }
      if ((this.registro.dados.NR_TOURO2_PESO) > 0 && (this.registro.dados.NR_TOURO2_PECAS) > 0) {
        this.animais.touro.faixa2.media = ((this.registro.dados.NR_TOURO2_PESO) / (this.registro.dados.NR_TOURO2_PECAS) )
      } else {
        this.animais.touro.faixa2.media = 0
      }
      if ((this.registro.dados.NR_TOURO1_PESO) > 0 && (this.registro.dados.NR_TOURO1_PECAS) > 0) {
        this.animais.touro.faixa1.media = ((this.registro.dados.NR_TOURO1_PESO) / (this.registro.dados.NR_TOURO1_PECAS) )
      } else {
        this.animais.touro.faixa1.media = 0
      }
      if ((this.registro.dados.NR_TOURO0_PESO) > 0 && (this.registro.dados.NR_TOURO0_PECAS) > 0) {
        this.animais.touro.faixa0.media = ((this.registro.dados.NR_TOURO0_PESO) / (this.registro.dados.NR_TOURO0_PECAS) )
      } else {
        this.animais.touro.faixa0.media = 0
      }
      /* touro TOTAL */
      if ((this.registro.dados.NR_TOURO4_PESO) > 0 && (this.registro.dados.VL_TOURO4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_TOURO4_PESO / 15) * this.registro.dados.VL_TOURO4_ARROBA
        this.registro.dados.NR_TOURO4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_TOURO4_TOTAL = 0
      }
      if ((this.registro.dados.NR_TOURO3_PESO) > 0 && (this.registro.dados.VL_TOURO3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_TOURO3_PESO / 15) * this.registro.dados.VL_TOURO3_ARROBA
        this.registro.dados.NR_TOURO3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_TOURO3_TOTAL = 0
      }
      if ((this.registro.dados.NR_TOURO2_PESO) > 0 && (this.registro.dados.VL_TOURO2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_TOURO2_PESO / 15) * this.registro.dados.VL_TOURO2_ARROBA
        this.registro.dados.NR_TOURO2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_TOURO2_TOTAL = 0
      }
      if ((this.registro.dados.NR_TOURO1_PESO) > 0 && (this.registro.dados.VL_TOURO1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_TOURO1_PESO / 15) * this.registro.dados.VL_TOURO1_ARROBA
        this.registro.dados.NR_TOURO1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_TOURO1_TOTAL = 0
      }
      if ((this.registro.dados.NR_TOURO0_PESO) > 0 && (this.registro.dados.VL_TOURO0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_TOURO0_PESO / 15) * this.registro.dados.VL_TOURO0_ARROBA
        this.registro.dados.NR_TOURO0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_TOURO0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaNovilha() {
      if ((this.registro.dados.NR_NOVILHA4_PESO) > 0 && (this.registro.dados.NR_NOVILHA4_PECAS) > 0) {
        this.animais.novilha.faixa4.media = ((this.registro.dados.NR_NOVILHA4_PESO) / (this.registro.dados.NR_NOVILHA4_PECAS) )
      } else {
        this.animais.novilha.faixa4.media = 0
      }
       if ((this.registro.dados.NR_NOVILHA3_PESO) > 0 && (this.registro.dados.NR_NOVILHA3_PECAS) > 0) {
        this.animais.novilha.faixa3.media = ((this.registro.dados.NR_NOVILHA3_PESO) / (this.registro.dados.NR_NOVILHA3_PECAS) )
      } else {
        this.animais.novilha.faixa3.media = 0
      }
      if ((this.registro.dados.NR_NOVILHA2_PESO) > 0 && (this.registro.dados.NR_NOVILHA2_PECAS) > 0) {
        this.animais.novilha.faixa2.media = ((this.registro.dados.NR_NOVILHA2_PESO) / (this.registro.dados.NR_NOVILHA2_PECAS) )
      } else {
        this.animais.novilha.faixa2.media = 0
      }
      if ((this.registro.dados.NR_NOVILHA1_PESO) > 0 && (this.registro.dados.NR_NOVILHA1_PECAS) > 0) {
        this.animais.novilha.faixa1.media = ((this.registro.dados.NR_NOVILHA1_PESO) / (this.registro.dados.NR_NOVILHA1_PECAS) )
      } else {
        this.animais.novilha.faixa1.media = 0
      }
      if ((this.registro.dados.NR_NOVILHA0_PESO) > 0 && (this.registro.dados.NR_NOVILHA0_PECAS) > 0) {
        this.animais.novilha.faixa0.media = ((this.registro.dados.NR_NOVILHA0_PESO) / (this.registro.dados.NR_NOVILHA0_PECAS) )
      } else {
        this.animais.novilha.faixa0.media = 0
      }
      /* novilha TOTAL */
      if ((this.registro.dados.NR_NOVILHA4_PESO) > 0 && (this.registro.dados.VL_NOVILHA4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_NOVILHA4_PESO / 15) * this.registro.dados.VL_NOVILHA4_ARROBA
        this.registro.dados.NR_NOVILHA4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_NOVILHA4_TOTAL = 0
      }
      if ((this.registro.dados.NR_NOVILHA3_PESO) > 0 && (this.registro.dados.VL_NOVILHA3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_NOVILHA3_PESO / 15) * this.registro.dados.VL_NOVILHA3_ARROBA
        this.registro.dados.NR_NOVILHA3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_NOVILHA3_TOTAL = 0
      }
      if ((this.registro.dados.NR_NOVILHA2_PESO) > 0 && (this.registro.dados.VL_NOVILHA2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_NOVILHA2_PESO / 15) * this.registro.dados.VL_NOVILHA2_ARROBA
        this.registro.dados.NR_NOVILHA2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_NOVILHA2_TOTAL = 0
      }
      if ((this.registro.dados.NR_NOVILHA1_PESO) > 0 && (this.registro.dados.VL_NOVILHA1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_NOVILHA1_PESO / 15) * this.registro.dados.VL_NOVILHA1_ARROBA
        this.registro.dados.NR_NOVILHA1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_NOVILHA1_TOTAL = 0
      }
      if ((this.registro.dados.NR_NOVILHA0_PESO) > 0 && (this.registro.dados.VL_NOVILHA0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_NOVILHA0_PESO / 15) * this.registro.dados.VL_NOVILHA0_ARROBA
        this.registro.dados.NR_NOVILHA0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_NOVILHA0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaBoiCapao() {
      if ((this.registro.dados.NR_BOI_CAPAO4_PESO) > 0 && (this.registro.dados.NR_BOI_CAPAO4_PECAS) > 0) {
        this.animais.boicapao.faixa4.media = ((this.registro.dados.NR_BOI_CAPAO4_PESO) / (this.registro.dados.NR_BOI_CAPAO4_PECAS) )
      } else {
        this.animais.boicapao.faixa4.media = 0
      }
       if ((this.registro.dados.NR_BOI_CAPAO3_PESO) > 0 && (this.registro.dados.NR_BOI_CAPAO3_PECAS) > 0) {
        this.animais.boicapao.faixa3.media = ((this.registro.dados.NR_BOI_CAPAO3_PESO) / (this.registro.dados.NR_BOI_CAPAO3_PECAS) )
      } else {
        this.animais.boicapao.faixa3.media = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO2_PESO) > 0 && (this.registro.dados.NR_BOI_CAPAO2_PECAS) > 0) {
        this.animais.boicapao.faixa2.media = ((this.registro.dados.NR_BOI_CAPAO2_PESO) / (this.registro.dados.NR_BOI_CAPAO2_PECAS) )
      } else {
        this.animais.boicapao.faixa2.media = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO1_PESO) > 0 && (this.registro.dados.NR_BOI_CAPAO1_PECAS) > 0) {
        this.animais.boicapao.faixa1.media = ((this.registro.dados.NR_BOI_CAPAO1_PESO) / (this.registro.dados.NR_BOI_CAPAO1_PECAS) )
      } else {
        this.animais.boicapao.faixa1.media = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO0_PESO) > 0 && (this.registro.dados.NR_BOI_CAPAO0_PECAS) > 0) {
        this.animais.boicapao.faixa0.media = ((this.registro.dados.NR_BOI_CAPAO0_PESO) / (this.registro.dados.NR_BOI_CAPAO0_PECAS) )
      } else {
        this.animais.boicapao.faixa0.media = 0
      }
      /* boicapao TOTAL */
      if ((this.registro.dados.NR_BOI_CAPAO4_PESO) > 0 && (this.registro.dados.VL_BOI_CAPAO4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI_CAPAO4_PESO / 15) * this.registro.dados.VL_BOI_CAPAO4_ARROBA
        this.registro.dados.NR_BOI_CAPAO4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI_CAPAO4_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO3_PESO) > 0 && (this.registro.dados.VL_BOI_CAPAO3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI_CAPAO3_PESO / 15) * this.registro.dados.VL_BOI_CAPAO3_ARROBA
        this.registro.dados.NR_BOI_CAPAO3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI_CAPAO3_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO2_PESO) > 0 && (this.registro.dados.VL_BOI_CAPAO2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI_CAPAO2_PESO / 15) * this.registro.dados.VL_BOI_CAPAO2_ARROBA
        this.registro.dados.NR_BOI_CAPAO2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI_CAPAO2_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO1_PESO) > 0 && (this.registro.dados.VL_BOI_CAPAO1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI_CAPAO1_PESO / 15) * this.registro.dados.VL_BOI_CAPAO1_ARROBA
        this.registro.dados.NR_BOI_CAPAO1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI_CAPAO1_TOTAL = 0
      }
      if ((this.registro.dados.NR_BOI_CAPAO0_PESO) > 0 && (this.registro.dados.VL_BOI_CAPAO0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BOI_CAPAO0_PESO / 15) * this.registro.dados.VL_BOI_CAPAO0_ARROBA
        this.registro.dados.NR_BOI_CAPAO0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BOI_CAPAO0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaBufaloMacho() {
      if ((this.registro.dados.NR_BUFALO_MACHO4_PESO) > 0 && (this.registro.dados.NR_BUFALO_MACHO4_PECAS) > 0) {
        this.animais.bufalomacho.faixa4.media = ((this.registro.dados.NR_BUFALO_MACHO4_PESO) / (this.registro.dados.NR_BUFALO_MACHO4_PECAS) )
      } else {
        this.animais.bufalomacho.faixa4.media = 0
      }
       if ((this.registro.dados.NR_BUFALO_MACHO3_PESO) > 0 && (this.registro.dados.NR_BUFALO_MACHO3_PECAS) > 0) {
        this.animais.bufalomacho.faixa3.media = ((this.registro.dados.NR_BUFALO_MACHO3_PESO) / (this.registro.dados.NR_BUFALO_MACHO3_PECAS) )
      } else {
        this.animais.bufalomacho.faixa3.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO2_PESO) > 0 && (this.registro.dados.NR_BUFALO_MACHO2_PECAS) > 0) {
        this.animais.bufalomacho.faixa2.media = ((this.registro.dados.NR_BUFALO_MACHO2_PESO) / (this.registro.dados.NR_BUFALO_MACHO2_PECAS) )
      } else {
        this.animais.bufalomacho.faixa2.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO1_PESO) > 0 && (this.registro.dados.NR_BUFALO_MACHO1_PECAS) > 0) {
        this.animais.bufalomacho.faixa1.media = ((this.registro.dados.NR_BUFALO_MACHO1_PESO) / (this.registro.dados.NR_BUFALO_MACHO1_PECAS) )
      } else {
        this.animais.bufalomacho.faixa1.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO0_PESO) > 0 && (this.registro.dados.NR_BUFALO_MACHO0_PECAS) > 0) {
        this.animais.bufalomacho.faixa0.media = ((this.registro.dados.NR_BUFALO_MACHO0_PESO) / (this.registro.dados.NR_BUFALO_MACHO0_PECAS) )
      } else {
        this.animais.bufalomacho.faixa0.media = 0
      }
      /* bufalomacho TOTAL */
      if ((this.registro.dados.NR_BUFALO_MACHO4_PESO) > 0 && (this.registro.dados.VL_BUFALO_MACHO4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_MACHO4_PESO / 15) * this.registro.dados.VL_BUFALO_MACHO4_ARROBA
        this.registro.dados.NR_BUFALO_MACHO4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_MACHO4_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO3_PESO) > 0 && (this.registro.dados.VL_BUFALO_MACHO3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_MACHO3_PESO / 15) * this.registro.dados.VL_BUFALO_MACHO3_ARROBA
        this.registro.dados.NR_BUFALO_MACHO3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_MACHO3_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO2_PESO) > 0 && (this.registro.dados.VL_BUFALO_MACHO2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_MACHO2_PESO / 15) * this.registro.dados.VL_BUFALO_MACHO2_ARROBA
        this.registro.dados.NR_BUFALO_MACHO2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_MACHO2_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO1_PESO) > 0 && (this.registro.dados.VL_BUFALO_MACHO1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_MACHO1_PESO / 15) * this.registro.dados.VL_BUFALO_MACHO1_ARROBA
        this.registro.dados.NR_BUFALO_MACHO1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_MACHO1_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_MACHO0_PESO) > 0 && (this.registro.dados.VL_BUFALO_MACHO0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_MACHO0_PESO / 15) * this.registro.dados.VL_BUFALO_MACHO0_ARROBA
        this.registro.dados.NR_BUFALO_MACHO0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_MACHO0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaBufaloFemea() {
      if ((this.registro.dados.NR_BUFALO_FEMEA4_PESO) > 0 && (this.registro.dados.NR_BUFALO_FEMEA4_PECAS) > 0) {
        this.animais.bufalofemea.faixa4.media = ((this.registro.dados.NR_BUFALO_FEMEA4_PESO) / (this.registro.dados.NR_BUFALO_FEMEA4_PECAS) )
      } else {
        this.animais.bufalofemea.faixa4.media = 0
      }
       if ((this.registro.dados.NR_BUFALO_FEMEA3_PESO) > 0 && (this.registro.dados.NR_BUFALO_FEMEA3_PECAS) > 0) {
        this.animais.bufalofemea.faixa3.media = ((this.registro.dados.NR_BUFALO_FEMEA3_PESO) / (this.registro.dados.NR_BUFALO_FEMEA3_PECAS) )
      } else {
        this.animais.bufalofemea.faixa3.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA2_PESO) > 0 && (this.registro.dados.NR_BUFALO_FEMEA2_PECAS) > 0) {
        this.animais.bufalofemea.faixa2.media = ((this.registro.dados.NR_BUFALO_FEMEA2_PESO) / (this.registro.dados.NR_BUFALO_FEMEA2_PECAS) )
      } else {
        this.animais.bufalofemea.faixa2.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA1_PESO) > 0 && (this.registro.dados.NR_BUFALO_FEMEA1_PECAS) > 0) {
        this.animais.bufalofemea.faixa1.media = ((this.registro.dados.NR_BUFALO_FEMEA1_PESO) / (this.registro.dados.NR_BUFALO_FEMEA1_PECAS) )
      } else {
        this.animais.bufalofemea.faixa1.media = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA0_PESO) > 0 && (this.registro.dados.NR_BUFALO_FEMEA0_PECAS) > 0) {
        this.animais.bufalofemea.faixa0.media = ((this.registro.dados.NR_BUFALO_FEMEA0_PESO) / (this.registro.dados.NR_BUFALO_FEMEA0_PECAS) )
      } else {
        this.animais.bufalofemea.faixa0.media = 0
      }
      /* bufalofemea TOTAL */
      if ((this.registro.dados.NR_BUFALO_FEMEA4_PESO) > 0 && (this.registro.dados.VL_BUFALO_FEMEA4_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_FEMEA4_PESO / 15) * this.registro.dados.VL_BUFALO_FEMEA4_ARROBA
        this.registro.dados.NR_BUFALO_FEMEA4_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_FEMEA4_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA3_PESO) > 0 && (this.registro.dados.VL_BUFALO_FEMEA3_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_FEMEA3_PESO / 15) * this.registro.dados.VL_BUFALO_FEMEA3_ARROBA
        this.registro.dados.NR_BUFALO_FEMEA3_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_FEMEA3_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA2_PESO) > 0 && (this.registro.dados.VL_BUFALO_FEMEA2_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_FEMEA2_PESO / 15) * this.registro.dados.VL_BUFALO_FEMEA2_ARROBA
        this.registro.dados.NR_BUFALO_FEMEA2_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_FEMEA2_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA1_PESO) > 0 && (this.registro.dados.VL_BUFALO_FEMEA1_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_FEMEA1_PESO / 15) * this.registro.dados.VL_BUFALO_FEMEA1_ARROBA
        this.registro.dados.NR_BUFALO_FEMEA1_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_FEMEA1_TOTAL = 0
      }
      if ((this.registro.dados.NR_BUFALO_FEMEA0_PESO) > 0 && (this.registro.dados.VL_BUFALO_FEMEA0_ARROBA) > 0) {
        const resultado = (this.registro.dados.NR_BUFALO_FEMEA0_PESO / 15) * this.registro.dados.VL_BUFALO_FEMEA0_ARROBA
        this.registro.dados.NR_BUFALO_FEMEA0_TOTAL = Math.round(resultado * 100) / 100
      } else {
        this.registro.dados.NR_BUFALO_FEMEA0_TOTAL = 0
      }
      this.calculaTotal()
      this.calculaTotalGeral()

    },
    calculaTotal() { 
      /*************************************** BOI */
      this.animais.boi.pesoTotal = 0
      this.animais.boi.pesoTotal = 
          (this.registro.dados.NR_BOI4_PESO)  
        + (this.registro.dados.NR_BOI3_PESO)
        + (this.registro.dados.NR_BOI2_PESO)  
        + (this.registro.dados.NR_BOI1_PESO)  
        + (this.registro.dados.NR_BOI0_PESO)  
         
      this.animais.boi.pecasTotal = 0
      this.animais.boi.pecasTotal = 
          (this.registro.dados.NR_BOI4_PECAS)  
        + (this.registro.dados.NR_BOI3_PECAS)
        + (this.registro.dados.NR_BOI2_PECAS)  
        + (this.registro.dados.NR_BOI1_PECAS)  
        + (this.registro.dados.NR_BOI1_PECAS)  

      /*************************************** BOI */
      this.animais.BOI.pesoTotal = 0
      this.animais.BOI.pesoTotal = 
          (this.registro.dados.NR_BOI4_PESO)  
        + (this.registro.dados.NR_BOI3_PESO)
        + (this.registro.dados.NR_BOI2_PESO)  
        + (this.registro.dados.NR_BOI1_PESO)  
        + (this.registro.dados.NR_BOI0_PESO)  
         
      this.animais.BOI.pecasTotal = 0
      this.animais.BOI.pecasTotal = 
          (this.registro.dados.NR_BOI4_PECAS)  
        + (this.registro.dados.NR_BOI3_PECAS)
        + (this.registro.dados.NR_BOI2_PECAS)  
        + (this.registro.dados.NR_BOI1_PECAS)  
        + (this.registro.dados.NR_BOI0_PECAS)  

      /*************************************** TOURO */
      this.animais.touro.pesoTotal = 0
      this.animais.touro.pesoTotal = 
          (this.registro.dados.NR_TOURO4_PESO)  
        + (this.registro.dados.NR_TOURO3_PESO)
        + (this.registro.dados.NR_TOURO2_PESO)  
        + (this.registro.dados.NR_TOURO1_PESO)  
        + (this.registro.dados.NR_TOURO0_PESO)  
         
      this.animais.touro.pecasTotal = 0
      this.animais.touro.pecasTotal = 
          (this.registro.dados.NR_TOURO4_PECAS)  
        + (this.registro.dados.NR_TOURO3_PECAS)
        + (this.registro.dados.NR_TOURO2_PECAS)  
        + (this.registro.dados.NR_TOURO1_PECAS)  
        + (this.registro.dados.NR_TOURO0_PECAS)  

      /*************************************** NOVILHA */
      this.animais.novilha.pesoTotal = 0
      this.animais.novilha.pesoTotal = 
          (this.registro.dados.NR_NOVILHA4_PESO)  
        + (this.registro.dados.NR_NOVILHA3_PESO)
        + (this.registro.dados.NR_NOVILHA2_PESO)  
        + (this.registro.dados.NR_NOVILHA1_PESO)  
        + (this.registro.dados.NR_NOVILHA0_PESO)  
         
      this.animais.novilha.pecasTotal = 0
      this.animais.novilha.pecasTotal = 
          (this.registro.dados.NR_NOVILHA4_PECAS)  
        + (this.registro.dados.NR_NOVILHA3_PECAS)
        + (this.registro.dados.NR_NOVILHA2_PECAS)  
        + (this.registro.dados.NR_NOVILHA1_PECAS)  
        + (this.registro.dados.NR_NOVILHA0_PECAS)  

      /*************************************** BUFALO MACHO */        
      this.animais.bufalomacho.pesoTotal = 0
      this.animais.bufalomacho.pesoTotal = 
          (this.registro.dados.NR_BUFALO_MACHO4_PESO)  
        + (this.registro.dados.NR_BUFALO_MACHO3_PESO)
        + (this.registro.dados.NR_BUFALO_MACHO2_PESO)  
        + (this.registro.dados.NR_BUFALO_MACHO1_PESO)  
        + (this.registro.dados.NR_BUFALO_MACHO0_PESO)   

      this.animais.bufalomacho.pecasTotal = 0
      this.animais.bufalomacho.pecasTotal = 
          (this.registro.dados.NR_BUFALO_MACHO4_PECAS)  
        + (this.registro.dados.NR_BUFALO_MACHO3_PECAS)
        + (this.registro.dados.NR_BUFALO_MACHO2_PECAS)  
        + (this.registro.dados.NR_BUFALO_MACHO1_PECAS)  
        + (this.registro.dados.NR_BUFALO_MACHO0_PECAS)  

      /*************************************** BUFALO FEMEA */     
      this.animais.bufalofemea.pesoTotal = 0
      this.animais.bufalofemea.pesoTotal = 
          (this.registro.dados.NR_BUFALO_FEMEA4_PESO)  
        + (this.registro.dados.NR_BUFALO_FEMEA3_PESO)
        + (this.registro.dados.NR_BUFALO_FEMEA2_PESO)  
        + (this.registro.dados.NR_BUFALO_FEMEA1_PESO)  
        + (this.registro.dados.NR_BUFALO_FEMEA0_PESO)      
      
      this.animais.bufalofemea.pecasTotal = 0
      this.animais.bufalofemea.pecasTotal = 
          (this.registro.dados.NR_BUFALO_FEMEA4_PECAS)  
        + (this.registro.dados.NR_BUFALO_FEMEA3_PECAS)
        + (this.registro.dados.NR_BUFALO_FEMEA2_PECAS)  
        + (this.registro.dados.NR_BUFALO_FEMEA1_PECAS)  
        + (this.registro.dados.NR_BUFALO_FEMEA0_PECAS)         
  
      /*************************************** BUFALO FEMEA */   
      this.animais.boicapao.pesoTotal = 0
      this.animais.boicapao.pesoTotal = 
          (this.registro.dados.NR_BOI_CAPAO4_PESO)  
        + (this.registro.dados.NR_BOI_CAPAO3_PESO)
        + (this.registro.dados.NR_BOI_CAPAO2_PESO)  
        + (this.registro.dados.NR_BOI_CAPAO1_PESO)  
        + (this.registro.dados.NR_BOI_CAPAO0_PESO)  

      this.animais.boicapao.pecasTotal = 0
      this.animais.boicapao.pecasTotal = 
          (this.registro.dados.NR_BOI_CAPAO4_PECAS)  
        + (this.registro.dados.NR_BOI_CAPAO3_PECAS)
        + (this.registro.dados.NR_BOI_CAPAO2_PECAS)  
        + (this.registro.dados.NR_BOI_CAPAO1_PECAS)  
        + (this.registro.dados.NR_BOI_CAPAO0_PECAS)          
    },
    calculaTotalGeral() {
      /************************************** TOTAL GERAL */
      this.registro.dados.VL_TOTAL_BATE = 
          this.registro.dados.NR_BOI4_TOTAL
        + this.registro.dados.NR_BOI3_TOTAL
        + this.registro.dados.NR_BOI2_TOTAL
        + this.registro.dados.NR_BOI1_TOTAL
        + this.registro.dados.NR_BOI0_TOTAL

        + this.registro.dados.NR_BOI4_TOTAL
        + this.registro.dados.NR_BOI3_TOTAL
        + this.registro.dados.NR_BOI2_TOTAL
        + this.registro.dados.NR_BOI1_TOTAL
        + this.registro.dados.NR_BOI0_TOTAL

        + this.registro.dados.NR_TOURO4_TOTAL
        + this.registro.dados.NR_TOURO3_TOTAL
        + this.registro.dados.NR_TOURO2_TOTAL
        + this.registro.dados.NR_TOURO1_TOTAL
        + this.registro.dados.NR_TOURO0_TOTAL

        + this.registro.dados.NR_NOVILHA4_TOTAL
        + this.registro.dados.NR_NOVILHA3_TOTAL
        + this.registro.dados.NR_NOVILHA2_TOTAL
        + this.registro.dados.NR_NOVILHA1_TOTAL
        + this.registro.dados.NR_NOVILHA0_TOTAL

        + this.registro.dados.NR_BUFALO_MACHO4_TOTAL
        + this.registro.dados.NR_BUFALO_MACHO3_TOTAL
        + this.registro.dados.NR_BUFALO_MACHO2_TOTAL
        + this.registro.dados.NR_BUFALO_MACHO1_TOTAL
        + this.registro.dados.NR_BUFALO_MACHO0_TOTAL

        + this.registro.dados.NR_BUFALO_FEMEA4_TOTAL
        + this.registro.dados.NR_BUFALO_FEMEA3_TOTAL
        + this.registro.dados.NR_BUFALO_FEMEA2_TOTAL
        + this.registro.dados.NR_BUFALO_FEMEA1_TOTAL
        + this.registro.dados.NR_BUFALO_FEMEA0_TOTAL

        + this.registro.dados.NR_BOI_CAPAO4_TOTAL
        + this.registro.dados.NR_BOI_CAPAO3_TOTAL
        + this.registro.dados.NR_BOI_CAPAO2_TOTAL
        + this.registro.dados.NR_BOI_CAPAO1_TOTAL
        + this.registro.dados.NR_BOI_CAPAO0_TOTAL

        this.registro.dados.VL_FUNRURAL = this.registro.dados.VL_TOTAL_BATE * (this.registro.dados.PERCENTUAL_FUNRURAL / 100).toFixed(2)
        this.registro.dados.VL_TOTAL_BRUTO = this.registro.dados.VL_TOTAL_BATE + this.registro.dados.VL_FUNRURAL 
    }
  },
  async created () {
    let id = this.$route.params.id
    if ( id ) {
      this.controles.emAlteracao = true
      this.controles.falhaNaAbertura = false
      await this.abrirCompraGado( id )
      this.ajustarCamposRegistro(this.registro.dados)
     
    } else {
      this.controles.emAlteracao = false
      this.controles.falhaNaAbertura = false
      this.registro.dados.ABATE_ID = null
      this.registro.dados.DT_ABATE = Tools.getDataAtual()
      this.registro.dados.DT_VENCIMENTO = Tools.getDataAtual()
    }
  },
  watch: {
    /** BOI */
    /** boi - MEIDIA */
    'registro.dados.NR_BOI4_PESO': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI3_PESO': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI2_PESO': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI1_PESO': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI0_PESO': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI4_PECAS': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI3_PECAS': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI2_PECAS': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI1_PECAS': function (){
      this.calculaBoi()
    },
    'registro.dados.NR_BOI0_PECAS': function (){
      this.calculaBoi()
    },
    'registro.dados.VL_BOI4_ARROBA': function (){
      this.calculaBoi()
    },
    'registro.dados.VL_BOI3_ARROBA': function (){
      this.calculaBoi()
    },
    'registro.dados.VL_BOI2_ARROBA': function (){
      this.calculaBoi()
    },
    'registro.dados.VL_BOI1_ARROBA': function (){
      this.calculaBoi()
    },
    'registro.dados.VL_BOI0_ARROBA': function (){
      this.calculaBoi()
    },

    /************************************************** BOI - MEIDIA */
    'registro.dados.NR_BOI4_PESO': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI3_PESO': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI2_PESO': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI1_PESO': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI0_PESO': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI4_PECAS': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI_PECAS': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI2_PECAS': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI1_PECAS': function (){
      this.calculaBOI()
    },
    'registro.dados.NR_BOI0_PECAS': function (){
      this.calculaBOI()
    },
    'registro.dados.VL_BOI4_ARROBA': function (){
      this.calculaBOI()
    },
    'registro.dados.VL_BOI3_ARROBA': function (){
      this.calculaBOI()
    },
    'registro.dados.VL_BOI2_ARROBA': function (){
      this.calculaBOI()
    },
    'registro.dados.VL_BOI1_ARROBA': function (){
      this.calculaBOI()
    },
    'registro.dados.VL_BOI0_ARROBA': function (){
      this.calculaBOI()
    },
    /***************************************************** TOURO */
    'registro.dados.NR_TOURO4_PESO': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO3_PESO': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO2_PESO': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO1_PESO': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO0_PESO': function (){
      this.calculaTouro()
    },

    'registro.dados.NR_TOURO4_PECAS': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO3_PECAS': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO2_PECAS': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO1_PECAS': function (){
      this.calculaTouro()
    },
    'registro.dados.NR_TOURO0_PECAS': function (){
      this.calculaTouro()
    },
    
    'registro.dados.VL_TOURO4_ARROBA': function (){
      this.calculaTouro()
    },
    'registro.dados.VL_TOURO3_ARROBA': function (){
      this.calculaTouro()     
    },
    'registro.dados.VL_TOURO2_ARROBA': function (){
      this.calculaTouro()
    },
    'registro.dados.VL_TOURO1_ARROBA': function (){
      this.calculaTouro()
    },
    'registro.dados.VL_TOURO0_ARROBA': function (){
      this.calculaTouro()
    },
    /** NOVILHA - MEIDIA */
    'registro.dados.NR_NOVILHA4_PESO': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA3_PESO': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA2_PESO': function (){
      this.calculaNovilha()
    },
    'registro.dados.VL_NOVILHA1_PESO': function (){
      this.calculaNovilha()
    },
    'registro.dados.VL_NOVILHA0_PESO': function (){
      this.calculaNovilha()
    },

    'registro.dados.NR_NOVILHA4_PECAS': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA3_PECAS': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA2_PECAS': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA1_PECAS': function (){
      this.calculaNovilha()
    },
    'registro.dados.NR_NOVILHA0_PECAS': function (){
      this.calculaNovilha()
    },

    'registro.dados.VL_NOVILHA4_ARROBA': function (){
      this.calculaNovilha()
    },
    'registro.dados.VL_NOVILHA3_ARROBA': function (){
      this.calculaNovilha()     
    },
    'registro.dados.VL_NOVILHA2_ARROBA': function (){
      this.calculaNovilha()
    },
    'registro.dados.VL_NOVILHA1_ARROBA': function (){
      this.calculaNovilha()
    },
    'registro.dados.VL_NOVILHA0_ARROBA': function (){
      this.calculaNovilha()
    },
    'registro.dados.PERCENTUAL_FUNRURAL': function () {
      this.calculaTotalGeral()
    },
    /** BOI CAPAO - MEIDIA */
    'registro.dados.NR_BOI_CAPAO4_PESO': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO3_PESO': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO2_PESO': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.VL_BOI_CAPAO1_PESO': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.VL_BOI_CAPAO0_PESO': function (){
      this.calculaBoiCapao()
    },

    'registro.dados.NR_BOI_CAPAO4_PECAS': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO3_PECAS': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO2_PECAS': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO1_PECAS': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.NR_BOI_CAPAO0_PECAS': function (){
      this.calculaBoiCapao()
    },

    'registro.dados.VL_BOI_CAPAO4_ARROBA': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.VL_BOI_CAPAO3_ARROBA': function (){
      this.calculaBoiCapao()     
    },
    'registro.dados.VL_BOI_CAPAO2_ARROBA': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.VL_BOI_CAPAO1_ARROBA': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.VL_BOI_CAPAO0_ARROBA': function (){
      this.calculaBoiCapao()
    },
    'registro.dados.PERCENTUAL_FUNRURAL': function () {
      this.calculaBoiCapao()
    },
    /** BUFALO MACHO - MEIDIA */
    'registro.dados.NR_BUFALO_MACHO4_PESO': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO3_PESO': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO2_PESO': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.VL_BUFALO_MACHO1_PESO': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.VL_BUFALO_MACHO0_PESO': function (){
      this.calculaBufaloMacho()
    },

    'registro.dados.NR_BUFALO_MACHO4_PECAS': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO3_PECAS': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO2_PECAS': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO1_PECAS': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.NR_BUFALO_MACHO0_PECAS': function (){
      this.calculaBufaloMacho()
    },

    'registro.dados.VL_BUFALO_MACHO4_ARROBA': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.VL_BUFALO_MACHO3_ARROBA': function (){
      this.calculaBufaloMacho()     
    },
    'registro.dados.VL_BUFALO_MACHO2_ARROBA': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.VL_BUFALO_MACHO1_ARROBA': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.VL_BUFALO_MACHO0_ARROBA': function (){
      this.calculaBufaloMacho()
    },
    'registro.dados.PERCENTUAL_FUNRURAL': function () {
      this.calculaBufaloMacho()
    },
    /** BUFALO FEMEA - MEIDIA */
    'registro.dados.NR_BUFALO_FEMEA4_PESO': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA3_PESO': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA2_PESO': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.VL_BUFALO_FEMEA1_PESO': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.VL_BUFALO_FEMEA0_PESO': function (){
      this.calculaBufaloFemea()
    },

    'registro.dados.NR_BUFALO_FEMEA4_PECAS': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA3_PECAS': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA2_PECAS': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA1_PECAS': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.NR_BUFALO_FEMEA0_PECAS': function (){
      this.calculaBufaloFemea()
    },

    'registro.dados.VL_BUFALO_FEMEA4_ARROBA': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.VL_BUFALO_FEMEA3_ARROBA': function (){
      this.calculaBufaloFemea()     
    },
    'registro.dados.VL_BUFALO_FEMEA2_ARROBA': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.VL_BUFALO_FEMEA1_ARROBA': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.VL_BUFALO_FEMEA0_ARROBA': function (){
      this.calculaBufaloFemea()
    },
    'registro.dados.PERCENTUAL_FUNRURAL': function () {
      this.calculaBufaloFemea()
    }
    
  }
}
</script>
<style>
.negrito {
  font-weight: bold !important;
}
.campo {
  width: 25%;
  font-weight: bolder;
}
.campoTotal {
  width: 75%;
  font-weight: bolder;
}
.negrito {
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/compragado/CompraGadoCadastro.vue